import administrationLabels from './administrationLabels';

const labels = {
    MarkAsImportant: 'MarkAsImportant',
    FilterListContainsTheSameFilter: 'FilterListContainsTheSameFilter',
    FillAllFormFields: 'FillAllFormFields',
    FromMustBeSmaller: 'FromMustBeSmaller',
    TooltipUploadedClients: 'TooltipUploadedClients',
    TopOfUploadedClients: 'TopOfUploadedClients', // with params {{uploadedClientsDataCount}} / {{totalClientsDataCount}}
    Offset: 'Offset',
    OneTime: 'OneTime',
    SavePushNotificationTemplate: 'SavePushNotificationTemplate',
    SavePopUpNotificationTemplate: 'SavePopUpNotificationTemplate',
    SaveTelegramTemplate: 'SaveTelegramTemplate',
    SaveInternalMessageTemplate: 'SaveInternalMessageTemplate',
    From: 'From',
    Operator: 'Operator',
    To: 'To',
    DayOfMonth: 'DayOfMonth',
    File: 'File',
    OptionValue: 'OptionValue',
    Option: 'Option',
    TopResultsByCount: 'TopResultsByCount',
    Weekday: 'Weekday',
    ScheduleType: 'ScheduleType',
    Yes: 'Yes',
    No: 'No',
    Cancel: 'Cancel',
    RightValue: 'RightValue',
    Archive: 'Archive',
    Convert: 'Convert',
    ReportName: 'ReportName',
    Upload: 'Upload',
    ImageUploadRequirements: 'ImageUploadRequirements',
    Frequency: 'Frequency',
    ValidityPeriod: 'ValidityPeriod',
    PopUpNotificationTemplate: 'PopUpNotificationTemplate',
    CreatePushNotificationTemplate: 'CreatePushNotificationTemplate',
    CreatePopUpNotificationTemplate: 'CreatePopUpNotificationTemplate',
    CreateDynamicPopUpTemplate: 'CreateDynamicPopUpTemplate',
    ClonePushNotificationTemplate: 'ClonePushNotificationTemplate',
    ClonePopUpNotificationTemplate: 'ClonePopUpNotificationTemplate',
    CloneDynamicPopUpTemplate: 'CloneDynamicPopUpTemplate',
    EditPushNotificationTemplate: 'EditPushNotificationTemplate',
    EditPopUpNotificationTemplate: 'EditPopUpNotificationTemplate',
    EditDynamicPopUpTemplate: 'EditDynamicPopUpTemplate',
    SegmentSuccessfullyConvertedToReport: 'SegmentSuccessfullyConvertedToReport',
    TitleOfPushNotification: 'TitleOfPushNotification',
    EndDateMustBeBiggerThanStartDate: 'EndDateMustBeBiggerThanStartDate',
    StartDateMustBeSmallerThanEndDate: 'StartDateMustBeSmallerThanEndDate',
    StartDateMustBeBiggerThanCurrentDate: 'StartDateMustBeBiggerThanCurrentDate',
    Reset: 'Reset',
    Save: 'Save',
    Connect: 'Connect',
    Reconnect: 'Reconnect',
    Disconnect: 'Disconnect',
    Sport: 'Sport',
    Region: 'Region',
    DaysWithNumber: 'DaysWithNumber', // with params {days}
    BonusIsNotExist: 'BonusIsNotExist',
    CompositeSegmentWasSuccessfullySaved: 'CompositeSegmentWasSuccessfullySaved',
    StaticSegmentWasSuccessfullySaved: 'StaticSegmentWasSuccessfullySaved',
    InDaysAtThisMoment: 'InDaysAtThisMoment',
    DaysAgoAtThisMoment: 'DaysAgoAtThisMoment',
    SaveEmailTemplate: 'SaveEmailTemplate',
    SaveNonCustomerSegment: 'SaveNonCustomerSegment',
    SaveSMSTemplete: 'SaveSMSTemplete',
    SaveHooryTemplate: 'SaveHooryTemplate',
    SaveInternalMessageTemplete: 'SaveInternalMessageTemplete',
    SaveTelegramTemplete: 'SaveTelegramTemplete',
    SaveSMSTemplate: 'SaveSMSTemplate',
    SaveEmailTemplete: 'SaveEmailTemplete',
    SaveDynamicPopUpTemplate: 'SaveDynamicPopUpTemplate',
    CreateNonCustomerSegment: 'CreateNonCustomerSegment',
    FromDate: 'FromDate',
    MustBeSmallerThan: 'MustBeSmallerThan',
    ToDate: 'ToDate',
    InDays: 'InDays',
    DaysAgo: 'DaysAgo',
    DayOrDays: 'DayOrDays',
    TemplateIsNotUsed: 'TemplateIsNotUsed',
    UnionTooltipText: 'UnionTooltipText',
    IntersectTooltipText: 'IntersectTooltipText',
    DifferenceTooltipText: 'DifferenceTooltipText',
    MergeResultIs: 'MergeResultIs',
    Competition: 'Competition',
    TypeYourText: 'TypeYourText',
    Schedule: 'Schedule',
    Details: 'Details',
    GeneralDetails: 'GeneralDetails',
    General: 'General',
    EmailIsNotInCorrectFormat: 'EmailIsNotInCorrectFormat',
    MustContainsOnlyNumber: 'MustContainsOnlyNumber',
    AmountIsNotValid: 'AmountIsNotValid',
    NoDataFound: 'NoDataFound',
    NoDataInSelectedSegment: 'NoDataInSelectedSegment',
    ProviderType: 'ProviderType',
    ProviderName: 'ProviderName',
    ClientField: 'ClientField',
    TooltipClientField: 'TooltipClientField',
    UploadFile: 'UploadFile',
    IgnoreInvalids: 'IgnoreInvalids',
    IncludeDuplicates: 'IncludeDuplicates',
    PleaseAddFirstSegment: 'PleaseAddFirstSegment',
    SaveCompositeSegment: 'SaveCompositeSegment',
    SegmentContainerMustContainMinimumTwoSegments: 'SegmentContainerMustContainMinimumTwoSegments',
    PleaseAddSegment: 'PleaseAddSegment',
    TooltipCheckboxes: 'TooltipCheckboxes',
    TooltipStaticSegmentUploadFile: 'TooltipStaticSegmentUploadFile',
    TooltipIncludeDuplicates: 'TooltipIncludeDuplicates',
    EditDynamicSegment: 'EditDynamicSegment',
    DynamicSegmentNotContainBasicFiltersWarningMessage: 'DynamicSegmentNotContainBasicFiltersWarningMessage',
    DynamicSegmentNotContainAggregatedFiltersWarningMessage: 'DynamicSegmentNotContainAggregatedFiltersWarningMessage',
    NotContainBasicFilters: 'NotContainBasicFilters',
    NotContainAggregatedFilters: 'NotContainAggregatedFilters',
    FiltersContainer: 'FiltersContainer',
    DynamicSegmentFiltersContainerTooltipText: 'DynamicSegmentFiltersContainerTooltipText',
    SaveAsDraft: 'SaveAsDraft',
    Create: 'Create',
    Count: 'Count',
    SelectKPI: 'SelectKPI',
    LoadedKPIs: 'LoadedKPIs',
    ChooseSegment: 'ChooseSegment',
    CreateFromPredefinedSegment: 'CreateFromPredefinedSegment',
    Or: 'Or',
    ChooseTemplate: 'ChooseTemplate',
    CreateFromPredefinedTemplate: 'CreateFromPredefinedTemplate',
    PredefinedSegments: 'PredefinedSegments',
    PredefinedTemplates: 'PredefinedTemplates',
    PredefinedCustomerJourneys: 'PredefinedCustomerJourneys',
    Total: 'Total',
    TotalOf: 'TotalOf', // with params {{count}}
    DoYouWantToDeleteThisFilterItemFromDynamicSegmentFilterContainer:
        'DoYouWantToDeleteThisFilterItemFromDynamicSegmentFilterContainer',
    DeleteFilterFromDynamicSegmentFilterContainer: 'DeleteFilterFromDynamicSegmentFilterContainer',
    NoSegmentToDisplay: 'NoSegmentToDisplay',
    YourSegmentsWillAppearInThisContainerAsSoonAsYouSelectFilters:
        'YourSegmentsWillAppearInThisContainerAsSoonAsYouSelectFilters',
    DoYouWantToDeleteThisFilterGroupFromDynamicSegmentFilterContainer:
        'DoYouWantToDeleteThisFilterGroupFromDynamicSegmentFilterContainer',
    DoYouWantToDeleteThisFilterSchemaFromDynamicSegmentFilterContainer:
        'DoYouWantToDeleteThisFilterSchemaFromDynamicSegmentFilterContainer',
    DeleteFilterGroupFromDynamicSegmentFilterContainer: 'DeleteFilterGroupFromDynamicSegmentFilterContainer',
    DeleteFilterSchemaFromDynamicSegmentFilterContainer: 'DeleteFilterSchemaFromDynamicSegmentFilterContainer',
    DeleteGoalCampaign: 'DeleteGoalCampaign',
    Untitled: 'Untitled',
    SegmentCreation: 'SegmentCreation',
    DayOfYear: 'DayOfYear',
    ThisDayOfYear: 'ThisDayOfYear',
    CustomValues: 'CustomValues',
    TypeDescription: 'TypeDescription',
    ConsiderTime: 'ConsiderTime',
    ResultIn: 'ResultIn',
    ResultInTooltip: 'ResultInTooltip',
    NoResult: 'NoResult',
    SelectAFilterAndStartBuildingASegment: 'SelectAFilterAndStartBuildingASegment',
    SelectAFilter: 'SelectAFilter',
    Error: 'Error',
    Export: 'Export',
    Date: 'Date',
    DynamicDate: 'DynamicDate',
    StaticDate: 'StaticDate',
    Match: 'Match',
    TypeHere: 'TypeHere',
    Reason: 'Reason',
    CommunicationReasonNone: 'CommunicationReasonNone',
    CommunicationReasonPartOfOtherPromo: 'CommunicationReasonPartOfOtherPromo',
    CommunicationReasonPartOfExclusiveABTest: 'CommunicationReasonPartOfExclusiveABTest',
    CommunicationReasonPartOfControlGroup: 'CommunicationReasonPartOfControlGroup',
    CommunicationReasonClientExcluded: 'CommunicationReasonClientExcluded',
    CommunicationReasonAwardNotSent: 'CommunicationReasonAwardNotSent',
    CommunicationReasonUnsubscribed: 'CommunicationReasonUnsubscribed',
    CommunicationReasonBestChannelNotSet: 'CommunicationReasonBestChannelNotSet',
    CommunicationReasonBestChannelNotDefined: 'CommunicationReasonBestChannelNotDefined',
    CommunicationReasonAwardNotAllowed: 'CommunicationReasonAwardNotAllowed',
    CommunicationReasonClientBanned: 'CommunicationReasonClientBanned',
    CommunicationReasonNonCustomerIsClient: 'CommunicationReasonNonCustomerIsClient',
    CommunicationReasonClientInExclusionRule: 'CommunicationReasonClientInExclusionRule',
    CommunicationReasonInternalError: 'CommunicationReasonInternalError',
    CommunicationReasonExternalError: 'CommunicationReasonExternalError',
    CommunicationReasonInvalidContact: 'CommunicationReasonInvalidContact',
    CommunicationReasonBanServiceError: 'CommunicationReasonBanServiceError',
    CommunicationReasonPromoLimit: 'CommunicationReasonPromoLimit',
    CommunicationReasonPartOfTargetGroup: 'CommunicationReasonPartOfTargetGroup',
    ABTestFailReasonInternalError: 'ABTestFailReasonInternalError',
    ABTestFailReasonExternalError: 'ABTestFailReasonExternalError',
    ABTestFailReasonLimitError: 'ABTestFailReasonLimitError',
    ABTestControlGroupPercentageTooltip: 'ABTestControlGroupPercentageTooltip',
    ABTestPilotGroupPercentageTooltip: 'ABTestPilotGroupPercentageTooltip',
    ABTestClientLimitMessage: 'ABTestClientLimitMessage', // with params {abTestClientsLimit}
    Year: 'Year',
    Years: 'Years',
    Month: 'Month',
    Months: 'Months',
    Week: 'Week',
    Weeks: 'Weeks',
    Day: 'Day',
    Days: 'Days',
    Hour: 'Hour',
    Hours: 'Hours',
    Minute: 'Minute',
    Minutes: 'Minutes',
    Seconds: 'Seconds',
    Duration: 'Duration',
    WaitTime: 'WaitTime',
    Remaining: 'Remaining',
    SelectedItems: 'SelectedItems',
    Country: 'Country',
    Amount: 'Amount',
    AmountInCurrency: 'AmountInCurrency', // {currencyId}
    TotalAmountInCurrency: 'TotalAmountInCurrency', // {currencyId}
    Currency: 'Currency',
    CurrencyDescription: 'CurrencyDescription',
    Number: 'Number',
    NumberDescription: 'NumberDescription',
    Percent: 'Percent',
    PercentDescription: 'PercentDescription',
    Dependencies: 'Dependencies',
    Currencies: 'Currencies',
    StaticDay: 'StaticDay',
    DynamicDay: 'DynamicDay',
    Settings: 'Settings',
    Language: 'Language',
    LogOut: 'LogOut',
    ChooseLanguage: 'ChooseLanguage',
    AddButtonsRow: 'AddButtonsRow',
    AddButton: 'AddButton',
    ButtonsRow: 'ButtonsRow', // {index, total}
    ButtonsRowDescription: 'ButtonsRowDescription',
    ButtonsRowError: 'ButtonsRowError',
    AreYouSureYouWantToArchiveSegment: 'AreYouSureYouWantToArchiveSegment',
    AreYouSureYouWantToArchiveCampign: 'AreYouSureYouWantToArchiveCampign',
    AreYouSureYouWantToStopCampign: 'AreYouSureYouWantToStopCampign',
    AreYouSureYouWantToDeleteGoalCampaign: 'AreYouSureYouWantToDeleteGoalCampaign',
    DeleteSegment: 'DeleteSegment',
    DeleteTemplate: 'DeleteTemplate',
    DeleteCampaign: 'DeleteCampaign',
    DeleteSelectedSegments: 'DeleteSelectedSegments',
    DeleteSelectedCampaigns: 'DeleteSelectedCampaigns',
    DeleteSelectedTemplates: 'DeleteSelectedTemplates',
    DeleteSelectedSegmentsQuestion: 'DeleteSelectedSegmentsQuestion',
    DeleteSelectedCampaignsQuestion: 'DeleteSelectedCampaignsQuestion',
    DeleteSelectedTemplatesQuestion: 'DeleteSelectedTemplatesQuestion',
    ArchiveSelectedTemplatesQuestion: 'ArchiveSelectedTemplatesQuestion',
    ArchiveSelectedTemplates: 'ArchiveSelectedTemplates',
    AreYouSureYouWantToDeleteSegment: 'AreYouSureYouWantToDeleteSegment',
    AreYouSureYouWantToDeleteTemplate: 'AreYouSureYouWantToDeleteTemplate',
    AreYouSureYouWantToDeleteCampaign: 'AreYouSureYouWantToDeleteCampaign',
    ConvertToReport: 'ConvertToReport',
    ArchiveSegment: 'ArchiveSegment',
    ArchiveCampaign: 'ArchiveCampaign',
    ArchiveTemplate: 'ArchiveTemplate',
    Stop: 'Stop',
    StopCampaign: 'StopCampaign',
    ArchiveSelectedSegments: 'ArchiveSelectedSegments',
    ArchiveSelectedCampaigns: 'ArchiveSelectedCampaigns',
    ArchiveSelectedSegmentsQuestion: 'ArchiveSelectedSegmentsQuestion',
    ArchiveSelectedCampaignsQuestion: 'ArchiveSelectedCampaignsQuestion',
    AreYouSureYouWantToArchiveTemplate: 'AreYouSureYouWantToArchiveTemplate',
    UnarchiveSegment: 'UnarchiveSegment',
    UnarchiveCampaign: 'UnarchiveCampaign',
    UnarchiveSelectedCampaigns: 'UnarchiveSelectedCampaigns',
    UnarchiveSelectedCampaignsQuestion: 'UnarchiveSelectedCampaignsQuestion',
    UnarchiveSelectedSegments: 'UnarchiveSelectedSegments',
    AreYouSureYouWantToUnarchiveSegment: 'AreYouSureYouWantToUnarchiveSegment',
    AreYouSureYouWantToUnarchiveCampaign: 'AreYouSureYouWantToUnarchiveCampaign',
    UnArchiveTemplate: 'UnArchiveTemplate',
    AreYouSureYouWantToUnArchiveTemplate: 'AreYouSureYouWantToUnArchiveTemplate',
    UnArchiveSelectedTemplates: 'UnArchiveSelectedTemplates',
    UnarchiveSelectedTemplatesQuestion: 'UnarchiveSelectedTemplatesQuestion',
    PleaseChooseFile: 'PleaseChooseFile',
    Description: 'Description',
    MustContainMinimumCharacters: 'MustContainMinimumCharacters',
    MustContainMaximumCharacters: 'MustContainMaximumCharacters',
    MustContainMaximumBytes: 'MustContainMaximumBytes',
    PleaseAddFilters: 'PleaseAddFilters',
    Type: 'Type',
    NumberOfCustomers: 'NumberOfCustomers',
    GeneralInfo: 'GeneralInfo',
    Close: 'Close',
    SegmentInfo: 'SegmentInfo',
    SaveStaticSegment: 'SaveStaticSegment',
    PleaseUploadFile: 'PleaseUploadFile',
    First200Clients: 'First200Clients',
    UsedIn: 'UsedIn',
    SegmentIsNotUsed: 'SegmentIsNotUsed',
    UsageInCampaigns: 'UsageInCampaigns',
    Promotions: 'Promotions',
    Selected: 'Selected',
    NotSelected: 'NotSelected',
    Preview: 'Preview',
    First100Clients: 'First100Clients',
    ClientsCount: 'ClientsCount',
    Password: 'Password',
    NewPassword: 'NewPassword',
    ConfirmPassword: 'ConfirmPassword',
    PasswordValidation: 'PasswordValidation',
    PasswordsMustMatch: 'PasswordsMustMatch',
    ChangePassword: 'ChangePassword',
    SignIn: 'SignIn',
    ResetPassword: 'ResetPassword',
    ConfirmResetPassword: 'ConfirmResetPassword',
    ForgotPassword: 'ForgotPassword',
    WeWillSendYouResetInstructions: 'WeWillSendYouResetInstructions',
    ResetPasswordMessageIsSentToYourEmail: 'ResetPasswordMessageIsSentToYourEmail',
    YourPasswordWasChangedSuccessfully: 'YourPasswordWasChangedSuccessfully',
    GoToLogInPage: 'GoToLogInPage',
    Welcome: 'Welcome',
    EasyWayToManageYourMarketingEffort: 'EasyWayToManageYourMarketingEffort',
    CRMDescription: 'CRMDescription',
    CRM: 'CRM',
    Success: 'Success',
    Warning: 'Warning',
    Filters: 'Filters',
    Delete: 'Delete',
    CreateDynamicSegment: 'CreateDynamicSegment',
    Apply: 'Apply',
    DynamicSegmentWasSuccessfullySaved: 'DynamicSegmentWasSuccessfullySaved',
    Segment: 'Segment',
    CompositeSegmentContainer: 'CompositeSegmentContainer',
    CompositeReportContainer: 'CompositeReportContainer',
    Dashboard: 'Dashboard',
    Template: 'Template',
    Campaign: 'Campaign',
    Journey: 'Journey',
    Report: 'Report',
    Analytics: 'Analytics',
    CreateSegment: 'CreateSegment',
    Dynamic: 'Dynamic',
    Static: 'Static',
    Composite: 'Composite',
    Segments: 'Segments',
    LoadingCompositeSegment: 'LoadingCompositeSegment',
    NoData: 'NoData',
    NoDataToDisplay: 'NoDataToDisplay',
    Title: 'Title',
    EnterTitleHere: 'EnterTitleHere',
    Collapse: 'Collapse',
    Expand: 'Expand',
    Browse: 'Browse',
    Search: 'Search',
    UploadedClients: 'UploadedClients',
    SegmentList: 'SegmentList',
    CampaignList: 'CampaignList',
    CampaignReportWithCampaignName: 'CampaignReportWithCampaignName', // with params {{campaignName}}
    CloneDynamicSegment: 'CloneDynamicSegment',
    CreateStaticSegment: 'CreateStaticSegment',
    CreateCompositeSegment: 'CreateCompositeSegment',
    CloneCompositeSegment: 'CloneCompositeSegment',
    EditCompositeSegment: 'EditCompositeSegment',
    MainApp: 'MainApp',
    NotFound: 'NotFound',
    SaveReport: 'SaveReport',
    ReportWasSuccessfullySaved: 'ReportWasSuccessfullySaved',
    CreateSMSTemplate: 'CreateSMSTemplate',
    CreateHooryTemplate: 'CreateHooryTemplate',
    CloneHooryTemplate: 'CloneHooryTemplate',
    EditHooryTemplate: 'EditHooryTemplate',
    CreateEmailTemplate: 'CreateEmailTemplate',
    CreateInternalMessageTemplate: 'CreateInternalMessageTemplate',
    CreateTelegramTemplate: 'CreateTelegramTemplate',
    CreateWhatsAppTemplate: 'CreateWhatsAppTemplate',
    EditWhatsAppTemplate: 'EditWhatsAppTemplate',
    CloneWhatsAppTemplate: 'CloneWhatsAppTemplate',
    WhatsAppTemplateContentAlert: 'WhatsAppTemplateContentAlert',
    CreateTemplate: 'CreateTemplate',
    Templates: 'Templates',
    CreateLabel: 'CreateLabel',
    EditLabel: 'EditLabel',
    ReportFields: 'ReportFields',
    SetLabel: 'SetLabel',
    ManageLabels: 'ManageLabels',
    MoreActions: 'MoreActions',
    FromDays: 'FromDays',
    ToDays: 'ToDays',
    Name: 'Name',
    ApiKey: 'ApiKey',
    NameDescriptionSection: 'NameDescriptionSection',
    Colors: 'Colors',
    DeleteLabel: 'DeleteLabel',
    RemoveLabel: 'RemoveLabel',
    NameLabelWithId: 'NameLabelWithId',
    StateNameLabel: 'StateNameLabel',
    AreYouSureWantToRemoveLabel: 'AreYouSureWantToRemoveLabel', // with params
    AreYouSureWantToDeleteLabel: 'AreYouSureWantToDeleteLabel', // with params
    Default: 'Default',
    TemplateInfo: 'TemplateInfo',
    PredefinedTemplateInfo: 'PredefinedTemplateInfo',
    AppType: 'AppType',
    DeviceType: 'DeviceType',
    Both: 'Both',
    Mobile: 'Mobile',
    Web: 'Web',
    Tablet: 'Tablet',
    Desktop: 'Desktop',
    FullScreen: 'FullScreen',
    TestTemplate: 'TestTemplate',
    TestTemplateDescription: 'TestTemplateDescription',
    SendNow: 'SendNow',
    InputClientId: 'InputClientId',
    EmailAddress: 'EmailAddress',
    AddLink: 'AddLink',
    TelegramChatId: 'TelegramChatId',
    PhoneNumber: 'PhoneNumber',
    SendTo: 'SendTo',
    Labels: 'Labels',
    SetLabels: 'SetLabels',
    QuickView: 'QuickView',
    Channel: 'Channel',
    ChannelList: 'ChannelList',
    Tracking: 'Tracking',
    Shortening: 'Shortening',
    State: 'State',
    Languages: 'Languages',
    User: 'User',
    CreatedDate: 'CreatedDate',
    ModifiedDate: 'ModifiedDate',
    Label: 'Label',
    LastModified: 'LastModified',
    Used: 'Used',
    NotUsed: 'NotUsed',
    CustomersType: 'CustomersType',
    DynamicVariables: 'DynamicVariables',
    TemplateDynamicVariablesTooltipTitle: 'TemplateDynamicVariablesTooltipTitle',
    TemplateDynamicVariablesTooltipText: 'TemplateDynamicVariablesTooltipText',
    TemplateAddTranslation: 'TemplateAddTranslation',
    SelectLanguage: 'SelectLanguage',
    Subject: 'Subject',
    SymbolsCountIn: 'SymbolsCountIn',
    Bytes: 'Bytes',
    CloneTemplate: 'CloneTemplate',
    CloneSMSTemplate: 'CloneSMSTemplate',
    TemplateList: 'TemplateList',
    SelectTheModeAndLeaveYourComment: 'SelectTheModeAndLeaveYourComment',
    CantChooseTheSameColumnForOneProperty: 'CantChooseTheSameColumnForOneProperty',
    Update: 'Update',
    HeaderIsTheFirstRow: 'HeaderIsTheFirstRow',
    HeaderIsTheFirstRowTooltip: 'HeaderIsTheFirstRowTooltip',
    SelectMode: 'SelectMode',
    Market: 'Market',
    Comment: 'Comment',
    NameFirstCharacterCantBeASymbol: 'NameFirstCharacterCantBeASymbol',
    EditTemplate: 'EditTemplate',
    EditSMSTemplate: 'EditSMSTemplate',
    FirstCharacterCantBeASymbol: 'FirstCharacterCantBeASymbol',
    TemplateWasSuccessfullySaved: 'TemplateWasSuccessfullySaved',
    CloneInternalMessageTemplate: 'CloneInternalMessageTemplate',
    EditInternalMessageTemplate: 'EditInternalMessageTemplate',
    EditTelegramTemplate: 'EditTelegramTemplate',
    CloneTelegramTemplate: 'CloneTelegramTemplate',
    CloneEmailTemplate: 'CloneEmailTemplate',
    EditEmailTemplate: 'EditEmailTemplate',
    ResetFilters: 'ResetFilters',
    Provider: 'Provider',
    Status: 'Status',
    LastRunDate: 'LastRunDate',
    AutoStart: 'AutoStart',
    AutoEnd: 'AutoEnd',
    NextRunDate: 'NextRunDate',
    Mode: 'Mode',
    Goal: 'Goal',
    GoalCount: 'GoalCount',
    SplitLogic: 'SplitLogic',
    SplitLogicInfo: 'SplitLogicInfo',
    SplitSegmentBy: 'SplitSegmentBy',
    MetricsForReport: 'MetricsForReport',
    MetricsForReportInfo: 'MetricsForReportInfo',
    MinimumDetectableEffect: 'MinimumDetectableEffect',
    CalculateMetricsButtonDescription: 'CalculateMetricsButtonDescription',
    Scheduled: 'Scheduled',
    Idle: 'Idle',
    InProgress: 'InProgress',
    Completed: 'Completed',
    Suspended: 'Suspended',
    Stopped: 'Stopped',
    Calculate: 'Calculate',
    Calculating: 'Calculating',
    Sent: 'Sent',
    Stoped: 'Stoped',
    NonStarted: 'NonStarted',
    Failed: 'Failed',
    Archived: 'Archived',
    Invalid: 'Invalid',
    All: 'All',
    Live: 'Live',
    Test: 'Test',
    ABTesting: 'ABTesting',
    New: 'New',
    ABTestBadgeDesc: 'ABTestBadgeDesc',
    Overview: 'Overview',
    Draft: 'Draft',
    Emulate: 'Emulate',
    CreateCampaign: 'CreateCampaign',
    EditCampaign: 'EditCampaign',
    CloneCampaign: 'CloneCampaign',
    CampaignReport: 'CampaignReport',
    CreateCustomerJourney: 'CreateCustomerJourney',
    Campaigns: 'Campaigns',
    PutTheFinalTouchBeforeSaving: 'PutTheFinalTouchBeforeSaving',
    PreSavePopUpDescription: 'PreSavePopUpDescription',
    SaveDynamicSegment: 'SaveDynamicSegment',
    PreSavePopUpGoToMassage: 'PreSavePopUpGoToMassage',
    CampaignInfo: 'CampaignInfo',
    CommunicationInfo: 'CommunicationInfo',
    FieldIsRequired: 'FieldIsRequired',
    Operation: 'Operation',
    ColumnsChooser: 'ColumnsChooser',
    TestTempalteDescription: 'TestTempalteDescription',
    CannotBeEmpty: 'CannotBeEmpty',
    NotAvailablePushNotificationRoute: 'NotAvailablePushNotificationRoute',
    InvalidHtmlTags: 'InvalidHtmlTags',
    UpdateDynamicSegment: 'UpdateDynamicSegment',
    ap: 'PersianAZ',
    ar: 'Arabic',
    az: 'Azerbaijani',
    bg: 'Bulgarian',
    bn: 'Bengali',
    cn: 'CanadianEnglish',
    cs: 'Czech',
    da: 'Danish',
    de: 'German',
    el: 'Greek',
    en: 'English',
    es: 'Spanish',
    et: 'Estonian',
    fa: 'Persian',
    fi: 'Finnish',
    fr: 'French',
    he: 'Hebrew',
    hr: 'Croatian',
    hy: 'Armenian',
    id: 'BahasaIndonesia',
    it: 'Italian',
    ja: 'Japanese',
    ka: 'Georgian',
    kk: 'Kazakh',
    ko: 'Korean',
    ku: 'Kurdish',
    lt: 'Lithuanian',
    lv: 'Latvian',
    mg: 'Malagasy',
    mk: 'Macedonian',
    ms: 'Malay',
    nl: 'Dutch',
    no: 'Norwegian',
    pb: 'BrazilianPortuguese',
    pl: 'Polski',
    pt: 'Português',
    ro: 'Romanian',
    rt: 'RussianTranslit',
    ru: 'Russian',
    sk: 'Slovak',
    sl: 'Slovene',
    sq: 'Albanian',
    sr: 'Serbian',
    sv: 'Swedish',
    sw: 'Swahili',
    th: 'Thai',
    tr: 'Turkish',
    uk: 'Ukrainian',
    us: 'USEnglish',
    uz: 'Uzbek',
    vi: 'Vietnamese',
    zh: 'Chinese',
    zs: 'ChineseSimplified',
    af: 'Afrikaans',
    ca: 'Catalan',
    fil: 'Filipino',
    gu: 'Gujarati',
    ha: 'Hausa',
    hi: 'Hindi',
    hu: 'Hungarian',
    ga: 'Irish',
    kn: 'Kannada',
    lo: 'Lao',
    ml: 'Malayalam',
    mr: 'Marathi',
    nb: 'Norwegian2',
    pa: 'Punjabi',
    ta: 'Tamil',
    te: 'Telugu',
    ur: 'Urdu',
    zu: 'Zulu',
    /* eslint-disable @typescript-eslint/naming-convention -- locale codes (e.g. ar_EG) must match API values for l[Language] lookup */
    ar_EG: 'ArabicEgypt',
    ar_AE: 'ArabicUAE',
    ar_LB: 'ArabicLebanon',
    ar_MA: 'ArabicMorocco',
    ar_QA: 'ArabicQatar',
    be_BY: 'Belarusian',
    bn_IN: 'BengaliIndia',
    zh_CN: 'ChineseChina',
    zh_HK: 'ChineseHongKong',
    zh_TW: 'ChineseTaiwan',
    prs_AF: 'Dari',
    nl_BE: 'DutchBelgium',
    en_GB: 'EnglishUK',
    en_US: 'EnglishUS',
    en_AE: 'EnglishUAE',
    en_AU: 'EnglishAustralia',
    en_CA: 'EnglishCanada',
    en_GH: 'EnglishGhana',
    en_IE: 'EnglishIreland',
    en_IN: 'EnglishIndia',
    en_JM: 'EnglishJamaica',
    en_MY: 'EnglishMalaysia',
    en_NZ: 'EnglishNewZealand',
    en_QA: 'EnglishQatar',
    en_SG: 'EnglishSingapore',
    en_UG: 'EnglishUganda',
    en_ZA: 'EnglishSouthAfrica',
    fr_BE: 'FrenchBelgium',
    fr_CA: 'FrenchCanada',
    fr_CH: 'FrenchSwitzerland',
    fr_CI: 'FrenchIvoryCoast',
    fr_MA: 'FrenchMorocco',
    de_AT: 'GermanAustria',
    de_CH: 'GermanSwitzerland',
    rw_RW: 'Kinyarwanda',
    ky_KG: 'KyrgyzKyrgyzstan',
    ps_AF: 'Pashto',
    pt_BR: 'PortugueseBrazil',
    pt_PT: 'PortuguesePortugal',
    si_LK: 'Sinhala',
    es_AR: 'SpanishArgentina',
    es_CL: 'SpanishChile',
    es_CO: 'SpanishColombia',
    es_CR: 'SpanishCostaRica',
    es_DO: 'SpanishDominicanRepublic',
    es_EC: 'SpanishEcuador',
    es_HN: 'SpanishHonduras',
    es_MX: 'SpanishMexico',
    es_PA: 'SpanishPanama',
    es_PE: 'SpanishPeru',
    es_ES: 'SpanishSpain',
    es_UY: 'SpanishUruguay',
    /* eslint-enable @typescript-eslint/naming-convention */
    ReportList: 'ReportList',
    Creator: 'Creator',
    LastModifier: 'LastModifier',
    Standart: 'Standart',
    Reports: 'Reports',
    CreateReport: 'CreateReport',
    ReportType: 'ReportType',
    CustomReport: 'CustomReport',
    ScheduleReport: 'ScheduleReport',
    DeleteSelectedReport: 'DeleteSelectedReport',
    DeleteSelectedReportsQuestion: 'DeleteSelectedReportsQuestion',
    DeleteSelectedReports: 'DeleteSelectedReports',
    AreYouSureYouWantToDeleteReport: 'AreYouSureYouWantToDeleteReport',
    EndDateMustBeBiggerThanCurrentDate: 'EndDateMustBeBiggerThanCurrentDate',
    SelectAtLeastOneUnit: 'SelectAtLeastOneUnit',
    SelectAtLeastOneWeek: 'SelectAtLeastOneWeek',
    AreYouSureYouWantToDeleteExecutedReport: 'AreYouSureYouWantToDeleteExecutedReport',
    ReportInfo: 'ReportInfo',
    CompositeReportInfo: 'CompositeReportInfo',
    DeleteReport: 'DeleteReport',
    ExecutedReportsList: 'ExecutedReportsList',
    ExecutedReportsListWithReportName: 'ExecutedReportsListWithReportName', // with params {{reportName}}
    CloneReport: 'CloneReport',
    EditReport: 'EditReport',
    Repeat: 'Repeat',
    StartDate: 'StartDate',
    StartTime: 'StartTime',
    EndDate: 'EndDate',
    StopReportSchedule: 'StopReportSchedule',
    UsageInWorkflows: 'UsageInWorkflows',
    CreateCustomRecurrence: 'CreateCustomRecurrence',
    CreateAMoreFlexibleScheduleForYourReport: 'CreateAMoreFlexibleScheduleForYourReport',
    Time: 'Time',
    ChooseCustomHours: 'ChooseCustomHours',
    ChooseCustomDays: 'ChooseCustomDays',
    ChooseCustomWeekdays: 'ChooseCustomWeekdays',
    ChooseCustomMonths: 'ChooseCustomMonths',
    ChooseCustomYear: 'ChooseCustomYear',
    Done: 'Done',
    FTPRecipients: 'FTPRecipients',
    EmailProviders: 'EmailProviders',
    CreateProvider: 'CreateProvider',
    Every: 'Every',
    DropHere: 'DropHere',
    DaysLater: 'DaysLater',
    DaysLeft: 'DaysLeft',
    TimeRemaining: 'TimeRemaining',
    SameDay: 'SameDay',
    LastDayOfMonth: 'LastDayOfMonth',
    Version: 'Version',
    ExecutionTime: 'ExecutionTime',
    ReportsResultGridTextLessThan: 'Lessthan1minute',
    DeleteExecutedReport: 'DeleteExecutedReport',
    Result: 'Result',
    History: 'History',
    SelectAll: 'SelectAll',
    IsLocalNetwork: 'IsLocalNetwork',
    CashWithdrawal: 'CashWithdrawal',
    NFTShop: 'NFTShop',
    Elements: 'Elements',
    Possible: 'Possible',
    Current: 'Current',
    Previous: 'Previous',
    Now: 'Now',
    Today: 'Today',
    Yesterday: 'Yesterday',
    ThisWeek: 'ThisWeek',
    ThreeDaysAgo: 'ThreeDaysAgo',
    LastWeek: 'LastWeek',
    AWeekAgo: 'AWeekAgo',
    LastMonth: 'LastMonth',
    OneDaysAgo: 'OneDaysAgo',
    SevenDaysAgo: 'SevenDaysAgo',
    ThrtyDaysAgo: 'ThrtyDaysAgo',
    Subtract: 'Subtract',
    Add: 'Add',
    Exact: 'Exact',
    FromAmount: 'FromAmount',
    ToAmount: 'ToAmount',
    Equivalent: 'Equivalent',
    AddFilters: 'AddFilters',
    None: 'None',
    FromMustBeSmallerThanTo: 'FromMustBeSmallerThanTo',
    ToMustBeBiggerThanFrom: 'ToMustBeBiggerThanFrom',
    FromCount: 'FromCount',
    ColumnKPIs: 'ColumnKPIs',
    Ok: 'Ok',
    CampaignSwitchChangeMessage: 'CampaignSwitchChangeMessage',
    CampaignSwitchChangeTitleMessage: 'CampaignSwitchChangeTitleMessage',
    OnlyOutliners: 'OnlyOutliners',
    WithoutOutliners: 'WithoutOutliners',
    Union: 'Union',
    Intersect: 'Intersect',
    Difference: 'Difference',
    ExportFileFormat: 'ExportFileFormat',
    Hourly: 'Hourly',
    Daily: 'Daily',
    Weekly: 'Weekly',
    Monthly: 'Monthly',
    Annually: 'Annually',
    ExecutedReport: 'ExecutedReport',
    ShowClientList: 'ShowClientList',
    HideClientList: 'HideClientList',
    Bonus: 'Bonus',
    CommunicationList: 'CommunicationList',
    SegmentDescription: 'SegmentDescription',
    TemplateDescription: 'TemplateDescription',
    BonusDescription: 'BonusDescription',
    Bonuses: 'Bonuses',
    IncludeInternalMessage: 'IncludeInternalMessage',
    BonusBudget: 'BonusBudget',
    BudgetSetup: 'BudgetSetup',
    CountLimit: 'CountLimit',
    AmountLimit: 'AmountLimit',
    BudgetPeriod: 'BudgetPeriod',
    LimitBehavior: 'LimitBehavior',
    BudgetPeriodLifetime: 'BudgetPeriodLifetime',
    BudgetPeriodMonth: 'BudgetPeriodMonth',
    BudgetPeriodWeek: 'BudgetPeriodWeek',
    BudgetPeriodExecution: 'BudgetPeriodExecution',
    BudgetPeriodYear: 'BudgetPeriodYear',
    LimitBehaviorWarn: 'LimitBehaviorWarn',
    LimitBehaviorWarnAndStop: 'LimitBehaviorWarnAndStop',
    BudgetLimitAlertMessage: 'BudgetLimitAlertMessage',
    TooltipBudgetPeriod: 'TooltipBudgetPeriod',
    TooltipLimitBehavior: 'TooltipLimitBehavior',
    AwardCount: 'AwardCount',
    AwardCountHint: 'AwardCountHint',
    BonusCalculation: 'BonusCalculation',
    BonusCalculationLogic: 'BonusCalculationLogic',
    BonusKind: 'BonusKind',
    BudgetAmount: 'BudgetAmount',
    BudgetInfo: 'BudgetInfo',
    BudgetSpent: 'BudgetSpent',
    PeriodStartDate: 'PeriodStartDate',
    PeriodEndDate: 'PeriodEndDate',
    AllowOverBudget: 'AllowOverBudget',
    BonusCalculateAction: 'BonusCalculateAction',
    Percentage: 'Percentage',
    ConsiderLimits: 'ConsiderLimits',
    TooltipBonusCalculationDynamic: 'TooltipBonusCalculationDynamic',
    TooltipBonusCalculationStatic: 'TooltipBonusCalculationStatic',
    TooltipBonusCalculationBonusKind: 'TooltipBonusCalculationBonusKind',
    TooltipBonusCalculationAction: 'TooltipBonusCalculationAction',
    TooltipBonusCalculationPercentage: 'TooltipBonusCalculationPercentage',
    TooltipBonusCalculationConsiderLimits: 'TooltipBonusCalculationConsiderLimits',
    Object: 'Object',
    KPI: 'KPI',
    FromFile: 'FromFile',
    TooltipBonusCalculationObject: 'TooltipBonusCalculationObject',
    TooltipBonusCalculationKPI: 'TooltipBonusCalculationKPI',
    TooltipBonusCalculationFromFile: 'TooltipBonusCalculationFromFile',
    SaveCampaign: 'SaveCampaign',
    CustomerJourneys: 'CustomerJourneys',
    DeleteSelectedCustomerJourneys: 'DeleteSelectedCustomerJourneys',
    DeleteSelectedCustomerJourneysQuestion: 'DeleteSelectedCustomerJourneysQuestion',
    DeleteCustomerJourney: 'DeleteCustomerJourney',
    AreYouSureYouWantToDeletCustomerJourney: 'AreYouSureYouWantToDeletCustomerJourney',
    ArchiveSelectedCustomerJourneys: 'ArchiveSelectedCustomerJourneys',
    ArchiveSelectedCustomerJourneysQuestion: 'ArchiveSelectedCustomerJourneysQuestion',
    ArchiveCustomerJourney: 'ArchiveCustomerJourney',
    AreYouSureYouWantToArchiveCustomerJourney: 'AreYouSureYouWantToArchiveCustomerJourney',
    UnarchiveSelectedCustomerJourneys: 'UnarchiveSelectedCustomerJourneys',
    UnarchiveSelectedCustomerJourneysQuestion: 'UnarchiveSelectedCustomerJourneysQuestion',
    UnarchiveCustomerJourney: 'UnarchiveCustomerJourney',
    AreYouSureYouWantToUnarchiveCustomerJourney: 'AreYouSureYouWantToUnarchiveCustomerJourney',
    StopCustomerJourney: 'StopCustomerJourney',
    StartCustomerJourney: 'StartCustomerJourney',
    AreYouSureYouWantToStartCustomerJourney: 'AreYouSureYouWantToStartCustomerJourney', // with params {{workflowName}}
    AreYouSureYouWantToStopCustomerJourney: 'AreYouSureYouWantToStopCustomerJourney', // with params {{workflowName}}
    AreYouSureYouWantToStartActionCampaign: 'AreYouSureYouWantToStartActionCampaign', // with params {{workflowName}}
    AreYouSureYouWantToStopActionCampaign: 'AreYouSureYouWantToStopActionCampaign', // with params {{workflowName}}
    NotAllowDeleteSelectedCustomerJourneys: 'NotAllowDeleteSelectedCustomerJourneys',
    AllowDeleteSelectedCustomerJourneys: 'AllowDeleteSelectedCustomerJourneys',
    NotAllowArchiveSelectedCustomerJourneys: 'NotAllowArchiveSelectedCustomerJourneys',
    AllowArchiveSelectedCustomerJourneys: 'AllowArchiveSelectedCustomerJourneys',
    NotAllowUnarchiveSelectedCustomerJourneys: 'NotAllowUnarchiveSelectedCustomerJourneys',
    AllowUnarchiveSelectedCustomerJourneys: 'AllowUnarchiveSelectedCustomerJourneys',
    Start: 'Start',
    Saving: 'Saving',
    Loading: 'Loading',
    MON: 'Mon',
    TUE: 'Tue',
    WED: 'Wed',
    THU: 'Thu',
    FRI: 'Fri',
    SAT: 'Sat',
    SUN: 'Sun',
    JAN: 'Jan',
    FEB: 'Feb',
    MAR: 'Mar',
    APR: 'Apr',
    MAY: 'May',
    JUN: 'Jun',
    JUL: 'Jul',
    AUG: 'Aug',
    SEP: 'Sep',
    OCT: 'Oct',
    NOV: 'Nov',
    DEC: 'Dec',
    RecurrenceCount: 'RecurrenceCount',
    ExecuteReport: 'ExecuteReport',
    DoYouWantToExecuteReport: 'DoYouWantToExecuteReport',
    DoYouWantToStopReportSchedule: 'DoYouWantToStopReportSchedule',
    NotAllowArchiveSelectedCampaigns: 'NotAllowArchiveSelectedCampaigns',
    AllowArchiveSelectedCampaigns: 'AllowArchiveSelectedCampaigns',
    NotAllowDeleteSelectedCampaigns: 'NotAllowDeleteSelectedCampaigns',
    AllowDeleteSelectedCampaigns: 'AllowDeleteSelectedCampaigns',
    NotAllowUnarchiveSelectedCampaigns: 'NotAllowUnarchiveSelectedCampaigns',
    AllowUnarchiveSelectedCampaigns: 'AllowUnarchiveSelectedCampaigns',
    NotAllowDeleteSelectedSegments: 'NotAllowDeleteSelectedSegments',
    AllowDeleteSelectedSegments: 'AllowDeleteSelectedSegments',
    NotAllowDeleteSelectedTemplates: 'NotAllowDeleteSelectedTemplates',
    AllowDeleteSelectedTemplates: 'AllowDeleteSelectedTemplates',
    NotAllowDeleteSelectedReports: 'NotAllowDeleteSelectedReports',
    AllowDeleteSelectedReports: 'AllowDeleteSelectedReports',
    AllowArchiveSelectedSegments: 'AllowArchiveSelectedSegments',
    NotAllowArchiveSelectedSegments: 'NotAllowArchiveSelectedSegments',
    AllowUnarchiveSelectedSegments: 'AllowUnarchiveSelectedSegments',
    NotAllowUnarchiveSelectedSegments: 'NotAllowUnarchiveSelectedSegments',
    AllowArchiveSelectedTemplates: 'AllowArchiveSelectedTemplates',
    NotAllowArchiveSelectedTemplates: 'NotAllowArchiveSelectedTemplates',
    AllowUnarchiveSelectedTemplates: 'AllowUnarchiveSelectedTemplates',
    NotAllowUnarchiveSelectedTemplates: 'NotAllowUnarchiveSelectedTemplates',
    Unarchive: 'Unarchive',
    PleaseChooseTemplate: 'PleaseChooseTemplate',
    PleaseChooseTemplateOrAward: 'PleaseChooseTemplateOrAward',
    NonCustomerSegmentTemplateSelectionError: 'NonCustomerSegmentTemplateSelectionError',
    PleaseChooseSegment: 'PleaseChooseSegment',
    PleaseChooseBonus: 'PleaseChooseBonus',
    PleaseFillBonusContent: 'PleaseFillBonusContent',
    MustBeGreaterThenZero: 'MustBeGreaterThenZero',
    MustBePositiveInteger: 'MustBePositiveInteger', // with params: {{fieldName}}
    BonusInfo: 'BonusInfo',
    Amounts: 'Amounts',
    MinAmount: 'MinAmount',
    MaxAmount: 'MaxAmount',
    Info: 'Info',
    CampaignActivity: 'CampaignActivity',
    ExecuteId: 'ExecuteId',
    TrackedLinks: 'TrackedLinks',
    ExcludedTrackingLinks: 'ExcludedTrackingLinks',
    LinkManagement: 'LinkManagement',
    LinkManagementDescription: 'LinkManagementDescription',
    BonusSummaryByStatus: 'BonusSummaryByStatus',
    BonusSummaryByCurrency: 'BonusSummaryByCurrency',
    BonusSummaryByCurrencyDescription: 'BonusSummaryByCurrencyDescription',
    BonusReceivedPlayers: 'BonusReceivedPlayers',
    EmailActivity: 'EmailActivity',
    CountOfSentBonus: 'CountOfSentBonus',
    CampaignKPI: 'CampaignKPI',
    ClientId: 'ClientId',
    ClientEmail: 'ClientEmail',
    TelegramClientId: 'TelegramClientId',
    Email: 'Email',
    FirstName: 'FirstName',
    LastName: 'LastName',
    Login: 'Login',
    MobilePhone: 'MobilePhone',
    WinAmount: 'WinAmount',
    OpenDate: 'OpenDate',
    ClickedDate: 'ClickedDate',
    SendDate: 'SendDate',
    SendCount: 'SendCount',
    OpenCount: 'OpenCount',
    ClickedCount: 'ClickedCount',
    NA: 'NA',
    UnarchiveSelectedSegmentsQuestion: 'UnarchiveSelectedSegmentsQuestion',
    LoadMore: 'LoadMore',
    LiveMonitoring: 'LiveMonitoring',
    Excel: 'Excel',
    AttachedSegment: 'AttachedSegment',
    SegmentType: 'SegmentType',
    SegmentCount: 'SegmentCount',
    AttachedTemplate: 'AttachedTemplate',
    AttachedBonus: 'AttachedBonus',
    BonusesSent: 'BonusesSent',
    GoalProgress: 'GoalProgress',
    OpenData: 'OpenData',
    ClickData: 'ClickData',
    ClientsClickedTrackedLink: 'ClientsClickedTrackedLink',
    CSV: 'CSV',
    CollectAnalysisBy: 'CollectAnalysisBy',
    CollectAnalysisPeriod: 'CollectAnalysisPeriod',
    TooltipCollectAnalysisBy: 'TooltipCollectAnalysisBy',
    Providers: 'Providers',
    Recipients: 'Recipients',
    GoalType: 'GoalType',
    GoalSection: 'GoalSection',
    Bet: 'Bet',
    Deposit: 'Deposit',
    CloneSegment: 'CloneSegment',
    EditSegment: 'EditSegment',
    ChangeCampaignMode: 'ChangeCampaignMode',
    CloneCustomerJourney: 'CloneCustomerJourney',
    EditCustomerJourney: 'EditCustomerJourney',
    ExecutedReports: 'ExecutedReports',
    ReloadData: 'ReloadData',
    TemplateIsUsedInObjects: 'TemplateIsUsedInObjects',
    TemplateIsUsedInWorkflows: 'TemplateIsUsedInWorkflows',
    TemplateIsUsedInCampaigns: 'TemplateIsUsedInCampaigns',
    Continue: 'Continue',
    SaveCustomerJourney: 'SaveCustomerJourney',
    Blocks: 'Blocks',
    Target: 'Target',
    Action: 'Action',
    Trigger: 'Trigger',
    Condition: 'Condition',
    Less: 'Less',
    More: 'More',
    DeleteSelectedBlocks: 'DeleteSelectedBlocks',
    DeleteSelectedBlocksConfirmationText: 'DeleteSelectedBlocksConfirmationText',
    DeleteSelectedBlocksWarningConfirmationText: 'DeleteSelectedBlocksWarningConfirmationText',
    DateRangeThreeMonthWarning: 'DateRangeThreeMonthWarning',
    CustomFields: 'CustomFields',
    NumberOfNonCustomers: 'NumberOfNonCustomers',
    IsUsedInObjectsLabel: 'IsUsedInObjectsLabel',
    CompositeSegments: 'CompositeSegments',
    And: 'And',
    TooltipIgnoreInvalids: 'TooltipIgnoreInvalids',
    IsNonMarketing: 'IsNonMarketing',
    IsNonMarketingPromotion: 'IsNonMarketingPromotion',
    IsNonMarketingDescription: 'IsNonMarketingDescription',
    IsNonMarketingPromotionDescription: 'IsNonMarketingPromotionDescription',
    CJBlockBetCalculated: 'CJBlockBetCalculated',
    CJBlockBetCalculatedDescription: 'CJBlockBetCalculatedDescription',
    CJBlockBetCalculatedDescriptionDescription: 'CJBlockBetCalculatedDescriptionDescription',
    CJBlockBonusClaim: 'CJBlockBonusClaim',
    CJBlockBonusClaimDescription: 'CJBlockBonusClaimDescription',
    CJBlockBonusComplete: 'CJBlockBonusComplete',
    CJBlockBonusCompleteDescription: 'CJBlockBonusCompleteDescription',
    CJBlockOptIn: 'CJBlockOptIn',
    CJBlockOptInDescription: 'CJBlockOptInDescription',
    CJBlockCasinoWin: 'CJBlockCasinoWin',
    CJBlockCasinoWinDescription: 'CJBlockCasinoWinDescription',
    CJBlockCasinoBet: 'CJBlockCasinoBet',
    CJBlockCasinoBetDescription: 'CJBlockCasinoBetDescription',
    CJBlockLinkTracker: 'CJBlockLinkTracker',
    CJBlockLinkTrackerDescription: 'CJBlockLinkTrackerDescription',
    CJBlockLose: 'CJBlockLose',
    CJBlockLoseDescription: 'CJBlockLoseDescription',
    CJBlockBet: 'CJBlockBet',
    CJBlockBetDescription: 'CJBlockBetDescription',
    CJBlockRealMoneyBet: 'CJBlockRealMoneyBet',
    CJBlockRealMoneyBetDescription: 'CJBlockRealMoneyBetDescription',
    CJBlockWin: 'CJBlockWin',
    CJBlockWinDescription: 'CJBlockWinDescription',
    CJBlockDeposit: 'CJBlockDeposit',
    CJBlockDepositDescription: 'CJBlockDepositDescription',
    CJBlockEmailTracker: 'CJBlockEmailTracker',
    CJBlockEmailTrackerDescription: 'CJBlockEmailTrackerDescription',
    CJBlockLogin: 'CJBlockLogin',
    CJBlockLoginDescription: 'CJBlockLoginDescription',
    CJBlockVerification: 'CJBlockVerification',
    CJBlockVerificationDescription: 'CJBlockVerificationDescription',
    CJBlockWithdrawal: 'CJBlockWithdrawal',
    CJBlockWithdrawalDescription: 'CJBlockWithdrawalDescription',
    CJBlockRegistration: 'CJBlockRegistration',
    CJBlockRegistrationDescription: 'CJBlockRegistrationDescription',
    CJBlockSegment: 'CJBlockSegment',
    CJBlockSegmentDescription: 'CJBlockSegmentDescription',
    CJBlockClientBet: 'CJBlockClientBet',
    CJBlockClientBetDescription: 'CJBlockClientBetDescription',
    CJBlockClientRealMoneyBet: 'CJBlockClientRealMoneyBet',
    CJBlockClientRealMoneyBetDescription: 'CJBlockClientRealMoneyBetDescription',
    CJBlockClientDeposit: 'CJBlockClientDeposit',
    CJBlockClientDepositDescription: 'CJBlockClientDepositDescription',
    CJBlockClientLogin: 'CJBlockClientLogin',
    CJBlockClientLoginDescription: 'CJBlockClientLoginDescription',
    CJBlockClientOptIn: 'CJBlockClientOptIn',
    CJBlockClientOptInDescription: 'CJBlockClientOptInDescription',
    CJBlockClientVerification: 'CJBlockClientVerification',
    CJBlockClientVerificationDescription: 'CJBlockClientVerificationDescription',
    CJBlockClientWithdrawal: 'CJBlockClientWithdrawal',
    CJBlockClientWithdrawalDescription: 'CJBlockClientWithdrawalDescription',
    CJBlockTelegramSender: 'CJBlockTelegramSender',
    CJBlockTelegramSenderDescription: 'CJBlockTelegramSenderDescription',
    CJBlockAggregator: 'CJBlockAggregator',
    CJBlockAggregatorDescription: 'CJBlockAggregatorDescription',
    CJBlockDynamicBonusSender: 'CJBlockDynamicBonusSender',
    CJBlockDynamicBonusSenderDescription: 'CJBlockDynamicBonusSenderDescription',
    CJBlockBonusSender: 'CJBlockBonusSender',
    CJBlockBonusSenderDescription: 'CJBlockBonusSenderDescription',
    CJBlockInternalMessageSender: 'CJBlockInternalMessageSender',
    CJBlockInternalMessageSenderDescription: 'CJBlockInternalMessageSenderDescription',
    CJBlockSmsSender: 'CJBlockSmsSender',
    CJBlockSmsSenderDescription: 'CJBlockSmsSenderDescription',
    CJBlockTagSetter: 'CJBlockTagSetter',
    CJBlockTagSetterDescription: 'CJBlockTagSetterDescription',
    CJBlockEmailSender: 'CJBlockEmailSender',
    CJBlockEmailSenderDescription: 'CJBlockEmailSenderDescription',
    CJBlockFilter: 'CJBlockFilter',
    CJBlockFilterReferenceDescription: 'CJBlockFilterReferenceDescription',
    CJBlockFilterDescription: 'CJBlockFilterDescription',
    CJBlockPushNotificationSender: 'CJBlockPushNotificationSender',
    CJBlockPushNotificationSenderDescription: 'CJBlockPushNotificationSenderDescription',
    CJBlockPopUpSender: 'CJBlockPopUpSender',
    CJBlockPopUpSenderDescription: 'CJBlockPopUpSenderDescription',
    CJBlockBonusActivation: 'CJBlockBonusActivation',
    CJBlockBonusActivationDescription: 'CJBlockBonusActivationDescription',
    CJBlockCalculateKPISegmentDescription: 'CJBlockCalculateKPISegmentDescription',
    CJBlockCalculateKPIObjectDescription: 'CJBlockCalculateKPIObjectDescription',
    CJBlockCalculateKPIKPIDescription: 'CJBlockCalculateKPIKPIDescription',
    CJBlockCalculateKPIFromFileDescription: 'CJBlockCalculateKPIFromFileDescription',
    CJBlockCalculateKPIKind: 'CJBlockCalculateKPIKind',
    CJBlockCalculateKPIKindDescription: 'CJBlockCalculateKPIKindDescription',
    CJBlockCalculateKPICalculateMethod: 'CJBlockCalculateKPICalculateMethod',
    CJBlockCalculateKPICalculateMethodDescription: 'CJBlockCalculateKPICalculateMethodDescription',
    CJBlockCalculateKPICalculateType: 'CJBlockCalculateKPICalculateType',
    CJBlockCalculateKPISegmentDoesNotContainKPIs: 'CJBlockCalculateKPISegmentDoesNotContainKPIs',
    CJBlockReportCellsExceedLimitWarning: 'CJBlockReportCellsExceedLimitWarning',
    CJReportCellsExceedLimitWarning: 'CJReportCellsExceedLimitWarning',
    Method: 'Method',
    SaveAsTest: 'SaveAsTest',
    SaveAsLive: 'SaveAsLive',
    SaveAndStart: 'SaveAndStart',
    SaveAndSchedule: 'SaveAndSchedule',
    PreSaveComment: 'PreSaveComment',
    CountOfSentMessage: 'CountOfSentMessage',
    ID: 'ID',
    TemplateName: 'TemplateName',
    BonusCount: 'BonusCount',
    DateTime: 'DateTime',
    Message: 'Message',
    Small: 'Small',
    Normal: 'Normal',
    Large: 'Large',
    Light: 'Light',
    Dark: 'Dark',
    EmailRecipients: 'EmailRecipients',
    ApplyChanges: 'ApplyChanges',
    DKPIActiveUsers: 'DKPIActiveUsers',
    DKPIActiveUsersToolTip: 'DKPIActiveUsersToolTip',
    DKPIRetentionRate: 'DKPIRetentionRate',
    DKPIRetentionRateToolTip: 'DKPIRetentionRateToolTip',
    DKPIConversionRate: 'DKPIConversionRate',
    DKPIConversionRateToolTip: 'DKPIConversionRateToolTip',
    DKPIMoneyRetentionRate: 'DKPIMoneyRetentionRate',
    DKPIMoneyRetentionRateToolTip: 'DKPIMoneyRetentionRateToolTip',
    DKPIDAUMAU: 'DKPIDAUMAU',
    DKPIDAUMAUToolTip: 'DKPIDAUMAUToolTip',
    Partners: 'Partners',
    BonusName: 'BonusName',
    SegmentName: 'SegmentName',
    MustBeBiggerThan: 'MustBeBiggerThan',
    DKPIDAUWAU: 'DKPIDAUWAU',
    DKPIDAUWAUToolTip: 'DKPIDAUWAUToolTip',
    DKPIARPU: 'DKPIARPU',
    DKPIARPUToolTip: 'DKPIARPUToolTip',
    DKPIReactivationRate: 'DKPIReactivationRate',
    DKPIReactivationRateToolTip: 'DKPIReactivationRateToolTip',
    DKPICLV: 'DKPICLV',
    DKPICLVToolTip: 'DKPICLVToolTip',
    Metrics: 'Metrics',
    WidgetsChooser: 'WidgetsChooser',
    KPIs: 'KPIs',
    Charts: 'Charts',
    CustomerRelationshipMetrics: 'CustomerRelationshipMetrics',
    CampaignsInAction: 'CampaignsInAction',
    Casino: 'Casino',
    Tomorrow: 'Tomorrow',
    KeyPerformanceIndicators: 'KeyPerformanceIndicators',
    ConversionTimeAnalytics: 'ConversionTimeAnalytics',
    ConversionTimeInterval: 'ConversionTimeInterval',
    TimePeriod: 'TimePeriod',
    DailyMetricsForNewCustomers: 'DailyMetricsForNewCustomers',
    DailyActiveCustomersByProductCategories: 'DailyActiveCustomersByProductCategories',
    OpenClickPerformanceVisualization: 'OpenClickPerformanceVisualization',
    DailyCommunicationMetrics: 'DailyCommunicationMetrics',
    CustomersSegmentationBasedOnRFMAnalysis: 'CustomersSegmentationBasedOnRFMAnalysis',
    Category: 'Category',
    TemplateCategory: 'TemplateCategory',
    Challenges: 'Challenges',
    PeriodCount: 'PeriodCount',
    SaveAchievement: 'SaveAchievement',
    Empty: 'Empty',
    ReRun: 'ReRun',
    Product: 'Product',
    PleaseSelectAtLeastOneProductType: 'PleaseSelectAtLeastOneProductType',
    ProductType: 'ProductType',
    ReRunCampaign: 'ReRunCampaign',
    DoYouWantToReRunCampaign: 'DoYouWantToReRunCampaign',
    PredefinedSegmentInfo: 'PredefinedSegmentInfo',
    DynamicSegmentInfo: 'DynamicSegmentInfo',
    StaticSegmentInfo: 'StaticSegmentInfo',
    CompositeSegmentInfo: 'CompositeSegmentInfo',
    AddFilter: 'AddFilter',
    Filter: 'Filter',
    PrimitiveValue: 'PrimitiveValue',
    Reference: 'Reference',
    FilterCondition: 'FilterCondition',
    Link: 'Link',
    ExcludeFreeBets: 'ExcludeFreeBets',
    ExcludeWageringBets: 'ExcludeWageringBets',
    StepId: 'StepId',
    ClientProfileLiveUpdate: 'ClientProfileLiveUpdate',
    AggregateProperty1: 'AggregateProperty1',
    AggregateProperty2: 'AggregateProperty2',
    AggregateProperty3: 'AggregateProperty3',
    AggregateProperty4: 'AggregateProperty4',
    AggregateProperty5: 'AggregateProperty5',
    AggregatedFilters: 'AggregatedFilters',
    AmountProperty: 'AmountProperty',
    ConsiderLimit: 'ConsiderLimit',
    Note: 'Note',
    TagName: 'TagName',
    Tag: 'Tag',
    SaveModeTitle: 'SaveModeTitle',
    ViewCustomerJourney: 'ViewCustomerJourney',
    ChartOfPlayersCount: 'ChartOfPlayersCount',
    PlayersReceived: 'PlayersReceived',
    PlayersWhoOpenedMail: 'PlayersWhoOpenedMail',
    PlayersWhoClickedTheLink: 'PlayersWhoClickedTheLink',
    Channels: 'Channels',
    Gender: 'Gender',
    BonusType: 'BonusType',
    BonusSum: 'BonusSum',
    AcceptanceType: 'AcceptanceType',
    IsUsed: 'IsUsed',
    ResultType: 'ResultType',
    PrimaryPhone: 'PrimaryPhone',
    Back: 'Back',
    Partner: 'Partner',
    Equal: 'Equal',
    NotEqual: 'NotEqual',
    GreaterThan: 'GreaterThan',
    GreaterThanEqual: 'GreaterThanEqual',
    LessThan: 'LessThan',
    LessThanEqual: 'LessThanEqual',
    IsNull: 'IsNull',
    IsNotNull: 'IsNotNull',
    OnlyFrom: 'OnlyFrom',
    IsEmpty: 'IsEmpty',
    IsNotEmpty: 'IsNotEmpty',
    StartsWith: 'StartsWith',
    EndsWith: 'EndsWith',
    Contains: 'Contains',
    DoesNotContain: 'DoesNotContain',
    Like: 'Like',
    GraphIsCyclicMessage: 'GraphIsCyclicMessage',
    ChartPlayersReceived: 'ChartPlayersReceived',
    ReceivedPlayers: 'ReceivedPlayers',
    Last7Days: 'Last7Days',
    Last30Days: 'Last30Days',
    Block: 'Block',
    Property: 'Property',
    BlockDoesNotExist: 'BlockDoesNotExist',
    BlockCollectedPropertiesNotExist: 'BlockCollectedPropertiesNotExist',
    MatchedBlockPropertyDoesNotVisible: 'MatchedBlockPropertyDoesNotVisible',
    MatchedBlockDoesNotVisible: 'MatchedBlockDoesNotVisible', // with params {{blockName}}
    BlockPropertyDoesNotExist: 'BlockPropertyDoesNotExist',
    SomethingIsWrong: 'SomethingIsWrong',
    ChartPlayersWhoOpenedMail: 'ChartPlayersWhoOpenedMail',
    Mail: 'Mail',
    Games: 'Games',
    CJAutoStartInputInfo: 'CJAutoStartInputInfo',
    CJAutoEndInputInfo: 'CJAutoEndInputInfo',
    ActivityTimeline: 'ActivityTimeline',
    View: 'View',
    NonCustomerInserted: 'Inserted',
    NonCustomerIgnored: 'Ignored',
    NonCustomerLeads: 'Leads',
    NonCustomerUpdated: 'Updated',
    NonCustomerSavedSuccess: 'NonCustomerSavedSuccess',
    NonCustomerSegmentAwardSelectionError: 'NonCustomerSegmentAwardSelectionError',
    FirstOperand: 'FirstOperand',
    SecondOperand: 'SecondOperand',
    SelectedOperator: 'SelectedOperator',
    TimeLineTable: 'TimeLineTable',
    CJActivity: 'CJActivity',
    UsageInSegment: 'UsageInSegment',
    MinimumTwoValidBlocksWithValidConnection: 'MinimumTwoValidBlocksWithValidConnection',
    LeastOneTargetBlock: 'LeastOneTargetBlock',
    AllBlocksMustBeConnected: 'AllBlocksMustBeConnected',
    TargetHasNotInput: 'TargetHasNotInput',
    BlockNameCanNotBeEmpty: 'BlockNameCanNotBeEmpty',
    BlockInvalid: 'BlockInvalid',
    Download: 'Download',
    DownloadAll: 'DownloadAll',
    Appearance: 'Appearance',
    CurrencyForReports: 'CurrencyForReports',
    AllowedPartners: 'AllowedPartners',
    Help: 'Help',
    Value: 'Value',
    FromValue: 'FromValue',
    ToValue: 'ToValue',
    TimeZone: 'TimeZone',
    CJAutoStartEndTimeZoneInfo: 'CJAutoStartEndTimeZoneInfo',
    XLS: 'XLS',
    Customers: 'Customers',
    NonCustomers: 'NonCustomers',
    UsageInReport: 'UsageInReport',
    UsageInCompositeReport: 'UsageInCompositeReport',
    UsageInWorkflowReport: 'UsageInWorkflowReport',
    NotClientYet: 'NotClientYet',
    Set: 'Set',
    SetGoal: 'SetGoal',
    Source: 'Source',
    WorkflowOverall: 'WorkflowOverall',
    SegmentOverall: 'SegmentOverall',
    TemplateOverall: 'TemplateOverall',
    WorkflowBlock: 'WorkflowBlock',
    Created: 'Created',
    Deleted: 'Deleted',
    WorkflowStarted: 'WorkflowStarted',
    WorkflowResume: 'WorkflowResume',
    WorkflowSuspend: 'WorkflowSuspend',
    WorkflowSegmentExecution: 'WorkflowSegmentExecution',
    Information: 'Information',
    CurrencyCode: 'CurrencyCode',
    BonusKPI: 'BonusKPI',
    On: 'On',
    Off: 'Off',
    BonusObjectKind: 'BonusObjectKind',
    ResumeCustomerJourney: 'ResumeCustomerJourney',
    AreYouSureYouWantToResumeCustomerJourney: 'AreYouSureYouWantToResumeCustomerJourney',
    Resume: 'Resume',
    ExecutionId: 'ExecutionId',
    PatternDoesNotMatch: 'PatternDoesNotMatch',
    MustBeBiggerOrEqualThan: 'MustBeBiggerOrEqualThan',
    MustBeSmallerOrEqualThan: 'MustBeSmallerOrEqualThan',
    MaximumNumberDecimalDigit: 'MaximumNumberDecimalDigit',
    CannotBeOnlyMinus: 'CannotBeOnlyMinus',
    ClientList: 'ClientList',
    SaveFilters: 'SaveFilters',
    WriteANameForTheFilter: 'WriteANameForTheFilter',
    FilterName: 'FilterName',
    SavedFilters: 'SavedFilters',
    CantCopy: 'CantCopy',
    HasNotAnySelectedBlock: 'HasNotAnySelectedBlock',
    CantCopyTarget: 'CantCopyTarget',
    SuccessCoped: 'SuccessCoped',
    CantPaste: 'CantPaste',
    CantPasteFromOtherPartner: 'CantPasteFromOtherPartner',
    NoFileChosen: 'NoFileChosen',
    WrongFileFormat: 'WrongFileFormat',
    WrongFileSize: 'WrongFileSize',
    HasUndeletableItemsMessage: 'HasUndeletableItemsMessage',
    Communication: 'Communication',
    ResendAction: 'ResendAction',
    LiveUpdate: 'LiveUpdate',
    ActionList: 'ActionList',
    ClientName: 'ClientName',
    SentDate: 'SentDate',
    PromotionName: 'PromotionName',
    PromotionType: 'PromotionType',
    Send: 'Send',
    AreYouSureYouWantToSendCommunicationToClient: 'AreYouSureYouWantToSendCommunicationToClient',
    YouHaveUnsavedChangesAreYouSureYouWantToLeavePage: 'YouHaveUnsavedChangesAreYouSureYouWantToLeavePage',
    Leave: 'Leave',
    LeavePage: 'LeavePage',
    Stay: 'Stay',
    Configuration: 'Configuration',
    Notifications: 'Notifications',
    BetWin: 'BetWin',
    WithdrawAprove: 'WithdrawAprove',
    WithdrawRejected: 'WithdrawRejected',
    MatchStarted: 'MatchStarted',
    MatchStartedWithPrices: 'MatchStartedWithPrices',
    MatchAboutStart: 'MatchAboutStart',
    MatchAboutStartWithPrices: 'MatchAboutStartWithPrices',
    MatchEnded: 'MatchEnded',
    FootballGoal: 'FootballGoal',
    FootballPenaltyStarted: 'FootballPenaltyStarted',
    FootballCorner: 'FootballCorner',
    FootballYellowCard: 'FootballYellowCard',
    FootballRedCard: 'FootballRedCard',
    Edit: 'Edit',
    EditNotifications: 'EditNotifications',
    FilterGroupWasSavedSuccessfully: 'FilterGroupWasSavedSuccessfully',
    FilterGroupWasDeletedSuccessfully: 'FilterGroupWasDeletedSuccessfully',
    DeleteFilterGroup: 'DeleteFilterGroup',
    AreYouSureYouWantToDeleteFilterGroup: 'AreYouSureYouWantToDeleteFilterGroup', //Are You Sure You Want to Delete {{filterTagName}} Filter Group
    FilterGroupNameAlreadyExistInFiltersGroupList: 'AlreadyExistInFiltersGroupList', //{{filterGroupName}} already exist in filters group list.
    AddFilterGroup: 'AddFilterGroup',
    FilterGroup: 'FilterGroup',
    CustomerJourneyReport: 'CustomerJourneyReport',
    CustomerJourneyReportInfo: 'CustomerJourneyReportInfo',
    CustomerJourneyReportWithJourneyName: 'CustomerJourneyReportWithJourneyName',
    ActionCampaignReportWithActionCampaignName: 'ActionCampaignReportWithActionCampaignName',
    Delivered: 'Delivered',
    Open: 'Open',
    Click: 'Click',
    TotalOpens: 'TotalOpens',
    TotalClicks: 'TotalClicks',
    Links: 'Links',
    OpenRate: 'OpenRate',
    ClickRate: 'ClickRate',
    ClickOnUnsubscribeLink: 'ClickOnUnsubscribeLink',
    TrackedLink: 'TrackedLink',
    ClientsWhoDeliveredMessage: 'ClientsWhoDeliveredMessage',
    ClientsWhoOpenMessage: 'ClientsWhoOpenMessage',
    ClientsWhoClickMessage: 'ClientsWhoClickMessage',
    ClientsWhoUnsubscribeLinkMessage: 'ClientsWhoUnsubscribeLinkMessage',
    ClientsWhoTrackedLinkMessage: 'ClientsWhoTrackedLinkMessage',
    Url: 'Url',
    ShareLink: 'ShareLink',
    UrlType: 'UrlType',
    SectionUrl: 'SectionUrl',
    CustomerJourneyKPIs: 'CustomerJourneyKPIs',
    ActionCampaignKPIs: 'ActionCampaignKPIs',
    CreateCustomerJourneyVisualization: 'CreateCustomerJourneyVisualization',
    EditCustomerJourneyVisualization: 'EditCustomerJourneyVisualization',
    SaveCustomerJourneyVisualization: 'SaveCustomerJourneyVisualization',
    AddStep: 'AddStep',
    Step: 'Step',
    SubStep: 'SubStep',
    Group: 'Group',
    Groups: 'Groups',
    GroupsSetting: 'GroupsSetting',
    NewGroup: 'NewGroup',
    AddGroup: 'AddGroup',
    VisualizationGroups: 'VisualizationGroups',
    IsHidden: 'IsHidden',
    IsLive: 'IsLive',
    NewStep: 'NewStep',
    StepsSetting: 'StepsSetting',
    Order: 'Order',
    Steps: 'Steps',
    CJVisualizationIsLiveInfo: 'CJVisualizationIsLiveInfo',
    CustomerJourneyAlreadyHasVisualization: 'CustomerJourneyAlreadyHasVisualization',
    NonCustomer: 'NonCustomer',
    SMS: 'SMS',
    Hoory: 'Hoory',
    InternalMessage: 'InternalMessage',
    Social: 'Social',
    Push: 'Push',
    PopUp: 'PopUp',
    DynamicPopUp: 'DynamicPopUp',
    CJInfo: 'CJInfo',
    PredefinedCustomerJourneyInfo: 'PredefinedCustomerJourneyInfo',
    CampaignWasSuccessfullySaved: 'CampaignWasSuccessfullySaved',
    ActionDate: 'ActionDate',
    CheckVisualizationMessage: 'CheckVisualizationMessage',
    WorkflowVisualization: 'WorkflowVisualization',
    CustomerJourneyIsInvalid: 'CustomerJourneyIsInvalid',
    IsInvalid: 'IsInvalid',
    Icons: 'Icons',
    ClassName: 'ClassName',
    Icon: 'Icon',
    CantGetIcons: 'CantGetIcons',
    ActionCampaignWasSuccessfullySaved: 'ActionCampaignWasSuccessfullySaved',
    CustomerJourneyWasSuccessfullySaved: 'CustomerJourneyWasSuccessfullySaved',
    CJVisualizationWasSuccessfullySaved: 'CJVisualizationWasSuccessfullySaved',
    Activities: 'Activities',
    ConfigurationNotificationsDescription: 'ConfigurationNotificationsDescription',
    ConfigurationProvidersDescription: 'ConfigurationProvidersDescription',
    ConfigurationGeneralDescription: 'ConfigurationGeneralDescription',
    FromAddress: 'FromAddress',
    SSL: 'SSL',
    Host: 'Host',
    SmsProviders: 'SmsProviders',
    UserName: 'UserName',
    AreYouSureYouWantToDeleteProvider: 'AreYouSureYouWantToDeleteProvider',
    AreYouSureYouWantToSetDefaultProvider: 'AreYouSureYouWantToSetDefaultProvider',
    SetDefault: 'SetDefault',
    SetDefaultEmailProvider: 'SetDefaultEmailProvider',
    SetDefaultSmsProvider: 'SetDefaultSmsProvider',
    DeleteEmailProvider: 'DeleteEmailProvider',
    DeleteSmsProvider: 'DeleteSmsProvider',
    FireBaseSettings: 'FireBaseSettings',
    FireBase: 'FireBase',
    OneSignal: 'OneSignal',
    ProviderFireBaseDescription: 'ProviderFireBaseDescription',
    ReportCustomerJourney: 'ReportCustomerJourney',
    SchedulerOnOff: 'SchedulerOnOff',
    Scheduling: 'Scheduling',
    CJBlockRemoveByTrip: 'CJBlockRemoveByTrip',
    CJBlockRemoveByTripDescription: 'CJBlockRemoveByTripDescription',
    CJBlockRemoveBySchedule: 'CJBlockRemoveBySchedule',
    CJBlockRemoveByScheduleDescription: 'CJBlockRemoveByScheduleDescription',
    CJBlockJoinToTournament: 'CJBlockJoinToTournament',
    CJBlockJoinToTournamentDescription: 'CJBlockJoinToTournamentDescription',
    BlockName: 'BlockName',
    CustomerJourney: 'CustomerJourney',
    Withdrawal: 'Withdrawal',
    Here: 'Here',
    DynamicVariablesAreInsideTheEditor: 'DynamicVariablesAreInsideTheEditor',
    DynamicVariablesAreNotSupported: 'DynamicVariablesAreNotSupported',
    PushNotification: 'PushNotification',
    PopUpNotification: 'PopUpNotification',
    Telegram: 'Telegram',
    WhatsApp: 'WhatsApp',
    WhatsAppProvider: 'WhatsAppProvider',
    Viber: 'Viber',
    NotificationCampaign: 'NotificationCampaign',
    Manual: 'Manual',
    TestSend: 'TestSend',
    TestUser: 'TestUser',
    TestUserDescription: 'TestUserDescription',
    TestUserSettingsSavedSuccessfully: 'TestUserSettingsSavedSuccessfully',
    TheChosenFileContainsInvalidEmails: 'TheChosenFileContainsInvalidEmails',
    SportBonus: 'SportBonus',
    DepositBonus: 'DepositBonus',
    NoDepositBonus: 'NoDepositBonus',
    CashBonus: 'CashBonus',
    FreeSpin: 'FreeSpin',
    FreeBet: 'FreeBet',
    SkillGames: 'SkillGames',
    CasinoFreeSpin: 'CasinoFreeSpin',
    FreeChip: 'FreeChip',
    FantasyTicket: 'FantasyTicket',
    LoyaltyPoint: 'LoyaltyPoint',
    AddSubStep: 'AddSubStep',
    NewSubStep: 'NewSubStep',
    VisualizationSteps: 'VisualizationSteps',
    Rewards: 'Rewards',
    ShowReward: 'ShowReward',
    Button: 'Button',
    ButtonName: 'ButtonName',
    ShowButton: 'ShowButton',
    Lock: 'Lock',
    UnlockCondition: 'UnlockCondition',
    PassSelectedStep: 'PassSelectedStep',
    CJCondition: 'CJCondition',
    DueDate: 'DueDate',
    Progress: 'Progress',
    Parameters: 'Parameters',
    RewardedBonus: 'RewardedBonus',
    ShowRewardDescription: 'ShowRewardDescription',
    ShowButtonDescription: 'ShowButtonDescription',
    LockDescription: 'LockDescription',
    DueDateDescription: 'DueDateDescription',
    ProgressDescription: 'ProgressDescription',
    BetWinDescription: 'BetWinDescription',
    WithdrawAproveDescription: 'WithdrawAproveDescription',
    WithdrawRejectedDescription: 'WithdrawRejectedDescription',
    MatchStartedDescription: 'MatchStartedDescription',
    MatchStartedWithPricesDescription: 'MatchStartedWithPricesDescription',
    MatchAboutStartDescription: 'MatchAboutStartDescription',
    MatchAboutStartWithPricesDescription: 'MatchAboutStartWithPricesDescription',
    MatchEndedDescription: 'MatchEndedDescription',
    FootballGoalDescription: 'FootballGoalDescription',
    FootballPenaltyStartedDescription: 'FootballPenaltyStartedDescription',
    WithdrawalDescription: 'WithdrawalDescription',
    DepositDescription: 'DepositDescription',
    ApplyFilterTag: 'ApplyFilterTag',
    DeleteFilterTag: 'DeleteFilterTag',
    LastYear: 'LastYear',
    LastThirtyMonths: 'LastThirtyMonths',
    FirstDayOfTheCurrentMonth: 'FirstDayOfTheCurrentMonth',
    FirstDayOfThePreviousMonth: 'FirstDayOfThePreviousMonth',
    ViewMode: 'ViewMode',
    ScheduleOffImmediately: 'ScheduleOffImmediately',
    TooltipDownloadTypeInfo: 'TooltipDownloadTypeInfo',
    UnsubscribeLink: 'UnsubscribeLink',
    Awards: 'Awards',
    AwardsDescription: 'AwardsDescription',
    AwardInfo: 'AwardInfo',
    ChooseAwardType: 'ChooseAwardType',
    EditAward: 'EditAward',
    CreateAwardingTitle: 'CreateAwardingTitle',
    EditAwardingTitle: 'EditAwardingTitle',
    SettingsPerCurrency: 'SettingsPerCurrency',
    Min: 'Min',
    Max: 'Max',
    IsNotValid: 'IsNotValid',
    MinCurrencyIsNotValid: 'MinCurrencyIsNotValid',
    MaxCurrencyIsNotValid: 'MaxCurrencyIsNotValid',
    MinMustBeSmallerThanMax: 'MinMustBeSmallerThanMax',
    MaxMustBeBiggerThanMin: 'MaxMustBeBiggerThanMin',
    LoyalityPointsEarned: 'LoyalityPointsEarned',
    CorrectionBonus: 'CorrectionBonus',
    LoyaltyPointsEarned: 'LoyaltyPointsEarned',
    AnalysisDateMustBeBiggerThanCurrentDate: 'AnalysisDateMustBeBiggerThanCurrentDate',
    AnalysisDateMustBeBiggerThanEndDate: 'AnalysisDateMustBeBiggerThanEndDate',
    AnalysisDateMustBeBiggerThanStartDate: 'AnalysisDateMustBeBiggerThanStartDate',
    MaxMustBeBiggerThanZero: 'MaxMustBeBiggerThanZero',
    LP: 'LP',
    ActivatedChannels: 'ActivatedChannels',
    SelectedTemplateName: 'SelectedTemplateName',
    SelectedProviderName: 'SelectedProviderName',
    EnterFirebaseToken: 'EnterFirebaseToken',
    FirebaseToken: 'FirebaseToken',
    AwardType: 'AwardType',
    BonusParametersAreSetupInSpringBackoffice: 'BonusParametersAreSetupInSpringBackoffice',
    SaveNotification: 'SaveNotification',
    NotificationsList: 'NotificationsList',
    NotificationIsLiveInfo: 'NotificationIsLiveInfo',
    SelectedChannels: 'SelectedChannels',
    StartDateMustBeSmallerThenBlockDate: 'StartDateMustBeSmallerThenBlockDate',
    EndDateMustBeBiggerThenBlockDate: 'EndDateMustBeBiggerThenBlockDate',
    TooltipImmediately: 'TooltipImmediately',
    Award: 'Award',
    StartDateMustBeSmallerThanEndDateWithOffset: 'StartDateMustBeSmallerThanEndDateWithOffset',
    EndDateMustBeBiggerThanStartDateWithOffset: 'EndDateMustBeBiggerThanStartDateWithOffset',
    NotificationCampaigns: 'NotificationCampaigns',
    InternalMessages: 'InternalMessages',
    ExportFileFormatCannotBeEmpty: 'ExportFileFormatCannotBeEmpty',
    CreateReportFromSegment: 'CreateReportFromSegment',
    RunImmediatelyInfoMessage: 'RunImmediatelyInfoMessage',
    PlayerId: 'PlayerId',
    Promotion: 'Promotion',
    PromotionId: 'PromotionId',
    Enabled: 'Enabled',
    Disabled: 'Disabled',
    BoostBonus: 'BoostBonus',
    ProviderIsNotIntegrated: 'ProviderIsNotIntegrated',
    ApplyExecutionDateAndTime: 'ApplyExecutionDateAndTime',
    ExecutionDate: 'ExecutionDate',
    ExecutionCount: 'ExecutionCount',
    TheDateWillBeChangedByThisExecutionStartAndEndDates: 'TheDateWillBeChangedByThisExecutionStartAndEndDates',
    SaveSegmentChangeIntoReport: 'SaveSegmentChangeIntoReport',
    SaveTheReportAndExecute: 'SaveTheReportAndExecute',
    WaitDataIsProcessed: 'WaitDataIsProcessed',
    DataTooBig: 'DataTooBig',
    PreSaveModalWarningMessage: 'PreSaveModalWarningMessage',
    ChildTemplateDoesNotContainDynamicVariable: 'ChildTemplateDoesNotContainDynamicVariable',
    ChildTemplateDoesNotContainDynamicVariableCascadeSMS: 'ChildTemplateDoesNotContainDynamicVariableCascadeSMS',
    ChildSubjectDoesNotContainDynamicVariable: 'ChildSubjectDoesNotContainDynamicVariable',
    DefaultTemplateDoesNotContainDynamicVariable: 'DefaultTemplateDoesNotContainDynamicVariable',
    DefaultTemplateDoesNotContainDynamicVariableCascadeSMS: 'DefaultTemplateDoesNotContainDynamicVariableCascadeSMS',
    DefaultSubjectDoesNotContainDynamicVariable: 'DefaultSubjectDoesNotContainDynamicVariable',
    Body: 'Body',
    CloneFromDefault: 'CloneFromDefault',
    DeleteSelectedLinesConfirmationText: 'DeleteSelectedLinesConfirmationText',
    DeleteSelectedLines: 'DeleteSelectedLines',
    CommunicationAvailabilityAlways: 'CommunicationAvailabilityAlways',
    CommunicationAvailabilitySameEveryDay: 'CommunicationAvailabilitySameEveryDay',
    CommunicationAvailabilityWeekdaysAndWeekend: 'CommunicationAvailabilityWeekdaysAndWeekend',
    CommunicationAvailabilityDaysOfTheWeek: 'CommunicationAvailabilityDaysOfTheWeek',
    Weekend: 'Weekend',
    Monday: 'Monday',
    Tuesday: 'Tuesday',
    Wednesday: 'Wednesday',
    Thursday: 'Thursday',
    Friday: 'Friday',
    Saturday: 'Saturday',
    Sunday: 'Sunday',
    CommunicationAvailabilityStartTime: 'CommunicationAvailabilityStartTime',
    CommunicationAvailabilityEndTime: 'CommunicationAvailabilityEndTime',
    StartTimeMustBeSmallerThenEndTimeWithOffset: 'StartTimeMustBeSmallerThenEndTimeWithOffset',
    EndTimeMustBeBiggerThenStartTimeWithOffset: 'EndTimeMustBeBiggerThenStartTimeWithOffset',
    CheckCommunicationAvailabilityScheduleDates: 'CheckCommunicationAvailabilityScheduleDates',
    CommunicationAvailabilityScheduleType: 'CommunicationAvailabilityScheduleType',
    Fail: 'Fail',
    NotStarted: 'NotStarted',
    Weekdays: 'Weekdays',
    CustomerJourneyLimitWarningMessage: 'CustomerJourneyLimitWarningMessage', // with params {{limit, count}}
    ActionCampaignLimitWarningMessage: 'ActionCampaignLimitWarningMessage', // with params {{limit, count}}
    CantPasteOutOfRangeBlocksCounts: 'CantPasteOutOfRangeBlocksCounts',
    BonusKindNotInRange: 'BonusKindNotInRange',
    BonusCalculationRadioNotInRange: 'BonusCalculationRadioNotInRange',
    Wallet: 'Wallet',
    WalletType: 'WalletType',
    AvailableBonusTypeAlert: 'AvailableBonusTypeAlert',
    CreateAward: 'CreateAward',
    SiteBuilderType: 'SiteBuilderType',
    EnterValidUrl: 'EnterValidUrl',
    OptionsSelected: 'OptionsSelected',
    SiteBuilderWasCreatedSuccessfully: 'SiteBuilderWasCreatedSuccessfully',
    Website: 'Website',
    SiteUrl: 'SiteUrl',
    CRMIsNotActiveTittle: 'CRMIsNotActiveTittle',
    CRMIsNotActiveDescription: 'CRMIsNotActiveDescription',
    CRMUnderMaintenanceTittle: 'CRMUnderMaintenanceTittle',
    CRMUnderMaintenanceDescription: 'CRMUnderMaintenanceDescription',
    UpcomingMaintenance: 'UpcomingMaintenance',
    UnderMaintenance: 'UnderMaintenance',
    UnderGoMaintenanceWarning: 'UnderGoMaintenanceWarning',
    GoToBME: 'GoToBME',
    ExecutedReportParameters: 'ExecutedReportParameters',
    NFTBonus: 'NFTBonus',
    Marketplace: 'Marketplace',
    ShowAll: 'ShowAll',
    ShowAllTooltipInfo: 'ShowAllTooltipInfo',
    SMSParts: 'SMSParts',
    CharactersCountIn: 'CharactersCountIn',
    MaxCharactersCountForSMSPartIsReached: 'MaxCharactersCountForSMSPartIsReached',
    DefaultTemplateContainUnknownDynamicVariable: 'DefaultTemplateContainUnknownDynamicVariable',
    DefaultTemplateContainUnknownDynamicVariableCascadeSMS: 'DefaultTemplateContainUnknownDynamicVariableCascadeSMS',
    DefaultSubjectContainUnknownDynamicVariable: 'DefaultSubjectContainUnknownDynamicVariable',
    TemplateContainDynamicVariableWithUnknownLength: 'TemplateContainDynamicVariableWithUnknownLength',
    TemplateForbiddenDynamicVariableErrorMessage: 'TemplateForbiddenDynamicVariableErrorMessage',
    TemplateContainDynamicVariableWithUnknownLengthCascadeSMS:
        'TemplateContainDynamicVariableWithUnknownLengthCascadeSMS',
    SubjectContainDynamicVariableWithUnknownLength: 'SubjectContainDynamicVariableWithUnknownLength',
    SetDefaultLanguageWarningMessage: 'SetDefaultLanguageWarningMessage',
    SetDefaultLanguage: 'SetDefaultLanguage',
    Confirm: 'Confirm',
    WarningMessage: 'WarningMessage',
    CompositeReportWasSuccessfullySaved: 'CompositeReportWasSuccessfullySaved',
    CreateCompositeReport: 'CreateCompositeReport',
    CloneCompositeReport: 'CloneCompositeReport',
    EditCompositeReport: 'EditCompositeReport',
    FirstPriority: 'FirstPriority',
    ChooseReport: 'ChooseReport',
    CompositeReports: 'CompositeReports',
    CompositeReport: 'CompositeReport',
    PleaseAddFirstReport: 'PleaseAddFirstReport',
    ReportContainerMustContainMinimumTwoReports: 'ReportContainerMustContainMinimumTwoReports',
    SaveCompositeReport: 'SaveCompositeReport',
    ExecutionsSelfComposite: 'ExecutionsSelfComposite',
    TelegramDescription: 'TelegramDescription',
    TelegramBotId: 'TelegramBotId',
    TelegramApiKey: 'TelegramApiKey',
    AppKey: 'AppKey',
    AppId: 'AppId',
    Outliner: 'Outliner',
    OutlinerDetection: 'OutlinerDetection',
    Histogram: 'Histogram',
    HistogramFor: 'HistogramFor',
    TelegramSettings: 'TelegramSettings',
    PushNotificationSettings: 'PushNotificationSettings',
    PushNotificationProviderSuccessfullySetAsDefault: 'PushNotificationProviderSuccessfullySetAsDefault',
    SetDefaultPushNotificationProvider: 'SetDefaultPushNotificationProvider',
    TelegramSettingsSavedSuccessfully: 'TelegramSettingsSavedSuccessfully',
    TelegramMaxUploadSizeError: 'TelegramMaxUploadSizeError', // with params {{maxUploadSizeInMegabytes}}
    TelegramSettingsDisconnectedSuccessfully: 'TelegramSettingsDisconnectedSuccessfully',
    DisconnectTelegram: 'DisconnectTelegram',
    DisconnectTelegramDescription: 'DisconnectTelegramDescription',
    WhatsAppSettings: 'WhatsAppSettings',
    AccessToken: 'AccessToken',
    WhatsAppBusinessAccountId: 'WhatsAppBusinessAccountId',
    PhoneNumberId: 'PhoneNumberId',
    WhatsAppSettingsDescription: 'WhatsAppSettingsDescription',
    WhatsAppSettingsSavedSuccessfully: 'WhatsAppSettingsSavedSuccessfully',
    WhatsAppSettingsDisconnectedSuccessfully: 'WhatsAppSettingsDisconnectedSuccessfully',
    DisconnectWhatsApp: 'DisconnectWhatsApp',
    DisconnectWhatsAppDescription: 'DisconnectWhatsAppDescription',
    OneSignalProviderDescription: 'OneSignalProviderDescription',
    OneSignalSettingsSavedSuccessfully: 'OneSignalSettingsSavedSuccessfully',
    CompositeReportUnionTooltipText: 'CompositeReportUnionTooltipText',
    CompositeReportIntersectTooltipText: 'CompositeReportIntersectTooltipText',
    CompositeReportFirstPriorityTooltipText: 'CompositeReportFirstPriorityTooltipText',
    CRMMigrationTittle: 'CRMMigrationTittle',
    CRMMigrationDescription: 'CRMMigrationDescription',
    VisibleTo: 'VisibleTo',
    AllPlayers: 'AllPlayers',
    CJPlayers: 'CJPlayers',
    DeleteSelectedExecutedReports: 'DeleteSelectedExecutedReports',
    DeleteSelectedExecutedReportsQuestion: 'DeleteSelectedExecutedReportsQuestion',
    AllowDeleteSelectedExecutedReports: 'AllowDeleteSelectedExecutedReports',
    NotAllowDeleteSelectedExecutedReports: 'NotAllowDeleteSelectedExecutedReports',
    MustBeLessOrEqualThan: 'MustBeLessOrEqualThan',
    MustBeLessThan: 'MustBeLessThan',
    TotalPercentageCalculation: 'TotalPercentageCalculation',
    TargetPercentageCalculation: 'TargetPercentageCalculation',
    IconSchemeHorizontal: 'IconSchemeHorizontal',
    IconSchemeVertical: 'IconSchemeVertical',
    Reload: 'Reload',
    TemplateId: 'TemplateId',
    SegmentId: 'SegmentId',
    CampaignId: 'CampaignId',
    ReportId: 'ReportId',
    ProviderId: 'ProviderId',
    EmailProviderId: 'EmailProviderId',
    SmsProviderId: 'SmsProviderId',
    WorkflowId: 'WorkflowId',
    CreateCustomerJourneyReport: 'CreateCustomerJourneyReport',
    EditCustomerJourneyReport: 'EditCustomerJourneyReport',
    CloneCustomerJourneyReport: 'CloneCustomerJourneyReport',
    SaveCustomerJourneyReport: 'SaveCustomerJourneyReport',
    PleaseSelectCustomerJourney: 'PleaseSelectCustomerJourney',
    PleaseSelectBlock: 'PleaseSelectBlock',
    PleaseAddCustomerJourneyKPIs: 'PleaseAddCustomerJourneyKPIs',
    SpinPriceValue: 'SpinPriceValue',
    SetDefaultFreeSpinExchangeRate: 'SetDefaultFreeSpinExchangeRate',
    EditFreeSpinExchangeRate: 'EditFreeSpinExchangeRate',
    DeleteFreeSpinExchangeRate: 'DeleteFreeSpinExchangeRate',
    AddFreeSpinExchangeRate: 'AddFreeSpinExchangeRate',
    AreYouSureYouWantToSetDefaultFreeSpinExchangeRate: 'AreYouSureYouWantToSetDefaultFreeSpinExchangeRate', //with params:  defaultFreeSpinExchangeRate, currentFreeSpinExchangeRate
    AreYouSureYouWantToDeleteFreeSpinExchangeRate: 'AreYouSureYouWantToDeleteFreeSpinExchangeRate', // with params: currencyName
    OneSpinPrice: 'OneSpinPrice',
    ReportContainerMustContainUniqueReports: 'ReportContainerMustContainUniqueReports',
    SegmentContainerMustContainUniqueSegments: 'SegmentContainerMustContainUniqueSegments',
    StaticSegmentBonusCurrencyAlertMessage: 'StaticSegmentBonusCurrencyAlertMessage',
    AutoFill: 'AutoFill',
    CurrencyAutoFillInfoAlert: 'CurrencyAutoFillInfoAlert',
    CurrencyAutoFillInfoAlertCreate: 'CurrencyAutoFillInfoAlertCreate',
    AmountMustBeBiggerThanZero: 'AmountMustBeBiggerThanZero',
    NumberMustHaveMaxNDecimals: 'NumberMustHaveMaxNDecimals', // with params: {{decimals}}
    CustomerJourneyBlock: 'CustomerJourneyBlock',
    InvalidCustomerJourneyReport: 'InvalidCustomerJourneyReport',
    SaveCMSPopUpNotificationTemplate: 'SaveCMSPopUpNotificationTemplate',
    CMSPopUp: 'CMSPopUp',
    CreateCMSPopUpNotificationTemplate: 'CreateCMSPopUpNotificationTemplate',
    EditCMSPopUpNotificationTemplate: 'EditCMSPopUpNotificationTemplate',
    CloneCMSPopUpNotificationTemplate: 'CloneCMSPopUpNotificationTemplate',
    CMSBannerTemplate: 'CMSBannerTemplate',
    CreateCMSBannerTemplate: 'CreateCMSBannerTemplate',
    EditCMSBannerTemplate: 'EditCMSBannerTemplate',
    CloneCMSBannerTemplate: 'CloneCMSBannerTemplate',
    PleaseSelectBanner: 'PleaseSelectBanner',
    SaveCMSBannerTemplate: 'SaveCMSBannerTemplate',
    BannerId: 'BannerId',
    BannerTitle: 'BannerTitle',
    BannerStartDate: 'BannerStartDate',
    BannerEndDate: 'BannerEndDate',
    BannerInfo: 'BannerInfo',
    Platform: 'Platform',
    Component: 'Component',
    BannerImagePreview: 'BannerImagePreview',
    PleaseSelectPopUp: 'PleaseSelectPopUp',
    CMSPopUpNotificationTemplate: 'CMSPopUpNotificationTemplate',
    CMSPopUpNotification: 'CMSPopUpNotification',
    CreateViberTemplate: 'CreateViberTemplate',
    CloneViberTemplate: 'CloneViberTemplate',
    EditViberTemplate: 'EditViberTemplate',
    SaveViberTemplate: 'SaveViberTemplate',
    ViberContent: 'ViberContent',
    SaveWhatsAppTemplate: 'SaveWhatsAppTemplate',
    SaveWhatsAppProviderTemplate: 'SaveWhatsAppProviderTemplate',
    SavePredefinedWhatsAppProviderTemplate: 'SavePredefinedWhatsAppProviderTemplate',
    CreateWhatsAppProviderTemplate: 'CreateWhatsAppProviderTemplate',
    CreatePredefinedWhatsAppProviderTemplate: 'CreatePredefinedWhatsAppProviderTemplate',
    EditWhatsAppProviderTemplate: 'EditWhatsAppProviderTemplate',
    EditPredefinedWhatsAppProviderTemplate: 'EditPredefinedWhatsAppProviderTemplate',
    CloneWhatsAppProviderTemplate: 'CloneWhatsAppProviderTemplate',
    ClonePredefinedWhatsAppProviderTemplate: 'ClonePredefinedWhatsAppProviderTemplate',
    SMSContent: 'SMSContent',
    ButtonText: 'ButtonText',
    ButtonUrl: 'ButtonUrl',
    MediaUrl: 'MediaUrl',
    Text: 'Text',
    Media: 'Media',
    MediaPreview: 'MediaPreview',
    InternalMessageTitle: 'InternalMessageTitle',
    MainSegment: 'MainSegment',
    SubSegment: 'SubSegment',
    SubSegmentUsedInMessage: 'SubSegmentUsedInMessage', //with params {usedInSegments}
    DeleteSubSegmentWarningMessage: 'DeleteSubSegmentWarningMessage',
    OpenCountTooltipInfoMessage: 'OpenCountTooltipInfoMessage',
    Route: 'Route',
    TemplateLanguagesDescription: 'TemplateLanguagesDescription',
    TemplateLanguagesPreSaveInfo: 'TemplateLanguagesPreSaveInfo',
    TemplateLanguagesUsage: 'TemplateLanguagesUsage', // with params templatesCount, clientsCount
    TemplateLanguages: 'TemplateLanguages',
    ArchiveExecutedReport: 'ArchiveExecutedReport',
    UnarchiveExecutedReport: 'UnarchiveExecutedReport',
    ArchiveExecutedReports: 'ArchiveExecutedReports',
    UnarchiveExecutedReports: 'UnarchiveExecutedReports',
    AllowArchiveSelectedExecutedReports: 'AllowArchiveSelectedExecutedReports',
    NotAllowArchiveSelectedExecutedReports: 'NotAllowArchiveSelectedExecutedReports',
    AllowUnarchiveSelectedExecutedReports: 'AllowUnarchiveSelectedExecutedReports',
    NotAllowUnarchiveSelectedExecutedReports: 'NotAllowUnarchiveSelectedExecutedReports',
    ArchiveSelectedExecutedReportsQuestion: 'ArchiveSelectedExecutedReportsQuestion',
    AreYouSureYouWantToArchiveExecutedReport: 'AreYouSureYouWantToArchiveExecutedReport',
    UnarchiveSelectedExecutedReportsQuestion: 'UnarchiveSelectedExecutedReportsQuestion',
    AreYouSureYouWantToUnarchiveExecutedReport: 'AreYouSureYouWantToUnarchiveExecutedReport',
    TemplateContainKPIDynamicVariable: 'TemplateContainKPIDynamicVariable',
    TemplateContainKPIDynamicVariableCascadeSMS: 'TemplateContainKPIDynamicVariableCascadeSMS',
    SubjectContainKPIDynamicVariable: 'SubjectContainKPIDynamicVariable',
    Clients: 'Clients',
    ViewClient: 'ViewClient',
    ShowTotalClientsIncludeRemoved: 'ShowTotalClientsIncludeRemoved',
    SelectedClientsCount: 'SelectedClientsCount',
    TotalClientsCount: 'TotalClientsCount',
    AreYouSureWantToDeleteTag: 'AreYouSureWantToDeleteTag',
    SetTag: 'SetTag',
    RemoveTag: 'RemoveTag',
    SetOnlyForSelection: 'SetOnlyForSelection',
    CreateTag: 'CreateTag',
    DeleteTag: 'DeleteTag',
    Remove: 'Remove',
    Clear: 'Clear',
    ManageClientTagFromFileHint: 'ManageClientTagFromFileHint',
    ManageClientTagHint: 'ManageClientTagHint',
    ClientTagWasSuccessfullyCreated: 'ClientTagWasSuccessfullyCreated',
    ClientTagWasSuccessfullySet: 'ClientTagWasSuccessfullySet',
    ClientTagWasSuccessfullyDeleted: 'ClientTagWasSuccessfullyDeleted',
    ClientTagWasSuccessfullyRemoved: 'ClientTagWasSuccessfullyRemoved',
    ClientTagWasSuccessfullySetOnlyForSelection: 'ClientTagWasSuccessfullySetOnlyForSelection',
    EasyJourney: 'EasyJourney',
    CreateEasyCustomerJourney: 'CreateEasyCustomerJourney',
    EditEasyCustomerJourney: 'EditEasyCustomerJourney',
    CloneEasyCustomerJourney: 'CloneEasyCustomerJourney',
    RegularJourney: 'RegularJourney',
    JourneyPage: 'JourneyPage',
    CreateRealTimePromotion: 'CreateRealTimePromotion',
    ActionCampaign: 'ActionCampaign',
    RealtimeActionCampaign: 'RealtimeActionCampaign',
    CreateActionCampaign: 'CreateActionCampaign',
    EditActionCampaign: 'EditActionCampaign',
    CloneActionCampaign: 'CloneActionCampaign',
    ViewActionCampaign: 'ViewActionCampaign',
    DeleteActionCampaign: 'DeleteActionCampaign',
    ArchiveActionCampaign: 'ArchiveActionCampaign',
    UnarchiveActionCampaign: 'UnarchiveActionCampaign',
    StopActionCampaign: 'StopActionCampaign',
    StartActionCampaign: 'StartActionCampaign',
    ResumeActionCampaign: 'ResumeActionCampaign',
    ActionCampaignInfo: 'ActionCampaignInfo',
    RealtimePromotionsList: 'RealtimePromotionsList',
    SaveRealtimeActionCampaign: 'SaveRealtimeActionCampaign',
    RealtimePromotion: 'RealtimePromotion',
    ChoosePromotionType: 'ChoosePromotionType',
    ReportActionCampaign: 'ReportActionCampaign',
    Starting: 'Starting',
    Updating: 'Updating',
    Resuming: 'Resuming',
    Suspending: 'Suspending',
    Pending: 'Pending',
    Succeeded: 'Succeeded',
    Approved: 'Approved',
    Rejected: 'Rejected',
    Skipped: 'Skipped',
    Queued: 'Queued',
    Missed: 'Missed',
    Cancelled: 'Cancelled',
    Clone: 'Clone',
    Skip: 'Skip',
    Unskip: 'Unskip',
    ExternalWhatsAppTemplateStatusNotApproved: 'ExternalWhatsAppTemplateStatusNotApproved',
    ExternalWhatsAppTemplateCategoryNotMarketing: 'ExternalWhatsAppTemplateCategoryNotMarketing',
    ExternalWhatsAppTemplateSubCategoryInvalid: 'ExternalWhatsAppTemplateSubCategoryInvalid',
    ExternalWhatsAppTemplateHeaderFormatUnsupported: 'ExternalWhatsAppTemplateHeaderFormatUnsupported',
    ExternalWhatsAppTemplateButtonDynamicUrlUnsupported: 'ExternalWhatsAppTemplateButtonDynamicUrlUnsupported',
    FilterByObjectType: 'FilterByObjectType',
    FilterByUser: 'FilterByUser',
    ViewSegment: 'ViewSegment',
    ViewTemplate: 'ViewTemplate',
    ViewCampaign: 'ViewCampaign',
    ViewRealtimePromotion: 'ViewRealtimePromotion',
    ViewReport: 'ViewReport',
    ArchiveReport: 'ArchiveReport',
    UnarchiveReport: 'UnarchiveReport',
    ArchiveSelectedReportsQuestion: 'ArchiveSelectedReportsQuestion', // with params {reportName}
    AreYouSureYouWantToArchiveReport: 'AreYouSureYouWantToArchiveReport',
    AllowArchiveSelectedReports: 'AllowArchiveSelectedReports',
    NotAllowArchiveSelectedReports: 'NotAllowArchiveSelectedReports',
    AllowUnarchiveSelectedReports: 'AllowUnarchiveSelectedReports',
    NotAllowUnarchiveSelectedReports: 'NotAllowUnarchiveSelectedReports',
    ManageTagFromFile: 'ManageTagFromFile',
    ManageTag: 'ManageTag',
    TooltipManageTagClientsUploadFile: 'TooltipManageTagClientsUploadFile',
    TooltipManageTagActions: 'TooltipManageTagActions',
    NewTagName: 'NewTagName',
    NoFileUploaded: 'NoFileUploaded',
    CampaignSchedulerOffInfoMessage: 'CampaignSchedulerOffInfoMessage',
    CJTargetSchedulerOffInfoMessage: 'CJTargetSchedulerOffInfoMessage',
    CJConditionSchedulerOffInfoMessage: 'CJConditionSchedulerOffInfoMessage',
    CJActionSchedulerOffInfoMessage: 'CJActionSchedulerOffInfoMessage',
    HtmlCodeEditor: 'HtmlCodeEditor',
    TextEditor: 'TextEditor',
    SwitchToTextEditorMode: 'SwitchToTextEditorMode',
    Switch: 'Switch',
    AreYouSureYouWantToSwitchEditorMode: 'AreYouSureYouWantToSwitchEditorMode',
    AreYouSureYouWantToSwitchToEditorModeWithClear: 'AreYouSureYouWantToSwitchToEditorModeWithClear',
    AreYouSureYouWantToLeaveEditorModeNotRecoverable: 'AreYouSureYouWantToLeaveEditorModeNotRecoverable',
    ImageGalleryModalTitle: 'ImageGalleryModalTitle',
    BlockEditor: 'BlockEditor',
    BlockEditorLegacy: 'BlockEditorLegacy',
    SwitchToBlockEditorMode: 'SwitchToBlockEditorMode',
    SwitchEditorModeTitle: 'SwitchEditorModeTitle',
    InvalidUnitPairCombination: 'InvalidUnitPairCombination',
    AccountID: 'AccountID',
    PleaseCompleteAllRequiredFields: 'PleaseCompleteAllRequiredFields',
    PleaseSelectCompositeOperation: 'PleaseSelectCompositeOperation',
    UserID: 'UserID',
    ProjectId: 'ProjectId',
    PrivateKeyId: 'PrivateKeyId',
    FirebaseSettingsClearedSuccessfully: 'FirebaseSettingsClearedSuccessfully',
    FirebaseSettingsUploadedSuccessfully: 'FirebaseSettingsUploadedSuccessfully',
    FirebaseSettingsFileIsInvalid: 'FirebaseSettingsFileIsInvalid',
    FirebaseDescription: 'FirebaseDescription',
    ClearSettings: 'ClearSettings',
    UploadSettings: 'UploadSettings',
    ClearFirebaseSettingsDescription: 'ClearFirebaseSettingsDescription',
    UploadFirebaseSettingsDescription: 'UploadFirebaseSettingsDescription',
    Expiry: 'Expiry',
    SyncWithPartnerCurrency: 'SyncWithPartnerCurrency',
    InCorrectDuration: 'InCorrectDuration',
    DeactivatedUser: 'DeactivatedUser',
    RemoveUnavailableSelection: 'RemoveUnavailableSelection',
    FrenchFreeBet: 'FrenchFreeBet',
    PrimaryWallet: 'PrimaryWallet',
    SelectExpirationDate: 'SelectExpirationDate',
    RewardDate: 'RewardDate',
    ExpirationDate: 'ExpirationDate',
    ExpirationType: 'ExpirationType',
    ExpirationPeriod: 'ExpirationPeriod',
    ExpirationDateMustBeGreaterThanNow: 'ExpirationDateMustBeGreaterThanNow',
    FromPayoutDate: 'FromPayoutDate',
    ToGivenDate: 'ToGivenDate',
    ExpirationTypeCannotBeEmpty: 'ExpirationTypeCannotBeEmpty',
    ExpirationDateIsInvalid: 'ExpirationDateIsInvalid',
    ExpirationPeriodIsInvalid: 'ExpirationPeriodIsInvalid',
    SelectPartner: 'SelectPartner',
    PartnerActiveTooltipText: 'PartnerActiveTooltipText',
    PartnerNotActiveTooltipText: 'PartnerNotActiveTooltipText',
    IdCopied: 'IdCopied',
    LoyaltyBenefit: 'LoyaltyBenefit',
    BonusWalletInfo: 'BonusWalletInfo',
    PromotionTimeline: 'PromotionTimeline',
    InvalidTime: 'InvalidTime',
    HomePage: 'HomePage',
    GoToPreviousPage: 'GoToPreviousPage',
    Next: 'Next',
    ABTestDesign: 'ABTestDesign',
    StopABTest: 'StopABTest',
    NotSet: 'NotSet',
    IsActive: 'IsActive',
    SegmentSplitPercentage: 'SegmentSplitPercentage',
    AnalyticsDuration: 'AnalyticsDuration',
    ErrorRate: 'ErrorRate',
    PilotGroup: 'PilotGroup',
    ControlGroup: 'ControlGroup',
    DayCount: 'DayCount',
    ABTestStartDate: 'ABTestStartDate',
    ABTestEndDate: 'ABTestEndDate',
    ABTestNoResultYet: 'ABTestNoResultYet',
    SegmentSplitEndDate: 'SegmentSplitEndDate',
    PleaseSelectSegment: 'PleaseSelectSegment',
    PleaseSelectASegmentAndAward: 'PleaseSelectASegmentAndAward',
    PleaseSelectAnAward: 'PleaseSelectAnAward',
    RemainingSegmentOverBudgetingIssue: 'RemainingSegmentOverBudgetingIssue',
    PassedABTests: 'PassedABTests',
    AtLeastOneKPIShouldBeSelected: 'AtLeastOneKPIShouldBeSelected',
    AtLeastTwoKPIsShouldBeSelected: 'AtLeastTwoKPIsShouldBeSelected',
    PressCalculateToEnableAllKPIsForABTest: 'PressCalculateToEnableAllKPIsForABTest',
    AreYouSureYouWantToStopTheABTest: 'AreYouSureYouWantToStopTheABTest',
    TheABTestWillBeFailedAnalyticPeriodNotPassed: 'TheABTestWillBeFailedAnalyticPeriodNotPassed',
    ABTestCompletedManagementUnavailableOnExistingPlan: 'ABTestCompletedManagementUnavailableOnExistingPlan',
    TheABTestWasStopped: 'TheABTestWasStopped',
    TheABTestWasStoppedWithFailedStatus: 'TheABTestWasStoppedWithFailedStatus',
    BonusDetailsGettingError: 'BonusDetailsGettingError',
    UnavailableBlockError: 'UnavailableBlockError',
    Timeline: 'Timeline',
    SelectedTimeZoneTime: 'SelectedTimeZoneTime',
    FiltersTimeZoneTime: 'FiltersTimeZoneTime',
    ImpactPercentage: 'ImpactPercentage',
    ImpactPercentageDescription: 'ImpactPercentageDescription',
    ConfidencePercentage: 'ConfidencePercentage',
    ConfidencePercentageDescription: 'ConfidencePercentageDescription',
    NoImpactDetected: 'NoImpactDetected',
    HighImpactDetected: 'HighImpactDetected',
    ABTest: 'ABTest',
    GeneralInformation: 'GeneralInformation',
    SegmentAnalysis: 'SegmentAnalysis',
    SegmentIntersectionAnalysis: 'SegmentIntersectionAnalysis',
    SegmentSize: 'SegmentSize',
    TotalUsers: 'TotalUsers',
    UnionSize: 'UnionSize',
    IntersectionSize: 'IntersectionSize',
    PercentageOfTotal: 'PercentageOfTotal', // {percentage}
    PercentageOfUnion: 'PercentageOfUnion', // {percentage}
    PleaseSelectAtLeastTwoSegments: 'PleaseSelectAtLeastTwoSegments',
    Intersection: 'Intersection',
    WonderWheelSpin: 'WonderWheelSpin',
    AddWonderWheelSpinExchangeRate: 'AddWonderWheelSpinExchangeRate',
    WonderWheelSpinPrice: 'WonderWheelSpinPrice',
    WonderWheelBonus: 'WonderWheelBonus',
    UsageType: 'UsageType',
    EditWonderWheelSpinExchangeRate: 'EditWonderWheelSpinExchangeRate',
    DeleteWonderWheelSpinExchangeRate: 'DeleteWonderWheelSpinExchangeRate',
    SetDefaultWonderWheelSpinExchangeRate: 'SetDefaultWonderWheelSpinExchangeRate',
    AreYouSureYouWantToDeleteWonderWheelSpinExchangeRate: 'AreYouSureYouWantToDeleteWonderWheelSpinExchangeRate', // {currencyName}
    ChooseCampaign: 'ChooseCampaign',
    MaxTotalNumberOfSpin: 'MaxTotalNumberOfSpin',
    NotBlacklisted: 'NotBlacklisted',
    Blacklisted: 'Blacklisted',
    SPIN: 'SPIN',
    UserManagement: 'UserManagement',
    FullName: 'FullName',
    Profile: 'Profile',
    WonderWheelId: 'WonderWheelId',
    WonderWheelName: 'WonderWheelName',
    NftVoucherId: 'NftVoucherId',
    NftVoucherName: 'NftVoucherName',
    NftVoucherBonus: 'NftVoucherBonus',
    NftVoucherCollection: 'NftVoucherCollection',
    BlockIsInvalid: 'BlockIsInvalid',
    NFTV: 'NFTV',
    FTN: 'FTN',
    PiePoints: 'PiePoints',
    AnalyticsPeriod: 'AnalyticsPeriod',
    Metric: 'Metric',
    MetricCalculationWarningMessage: 'MetricCalculationWarningMessage',
    CompositeSegmentUnionOperationWarningMessage: 'CompositeSegmentUnionOperationWarningMessage',
    SelectedWalletIsNotValidForChosenBonus: 'SelectedWalletIsNotValidForChosenBonus',
    UnsetBonusCurrenciesWarningMessage: 'UnsetBonusCurrenciesWarningMessage', // {currenciesList}
    UnsupportedBonusCurrenciesWarningMessage: 'UnsupportedBonusCurrenciesWarningMessage', // {currenciesList}
    PartnerInfo: 'PartnerInfo',
    Counts: 'Counts',
    DepositClientsCount: 'DepositClientsCount',
    DepositClientsCountToolTip: 'DepositClientsCountToolTip',
    PermissionsList: 'PermissionsList',
    Permission: 'Permission',
    Availability: 'Availability',
    BPIEP: 'BPIEP',
    MinCount: 'MinCount',
    MaxCount: 'MaxCount',
    AchievementMaxChallengesCountExceeded: 'AchievementMaxChallengesCountExceeded', // with params {{count}}
    Execution: 'Execution',
    Executions: 'Executions',
    TotalCount: 'TotalCount',
    TakeOnlyTopClients: 'TakeOnlyTopClients',
    Ascending: 'Ascending',
    Descending: 'Descending',
    MustBePositive: 'MustBePositive',
    MustBeInteger: 'MustBeInteger',
    ABTestStartDateInfo: 'ABTestStartDateInfo',
    TemplateMessageConfig: 'TemplateMessageConfig',
    ABTestEndDateInfo: 'ABTestEndDateInfo',
    SegmentSplitEndDateInfo: 'SegmentSplitEndDateInfo',
    ABTestDatesTimezoneDescription: 'ABTestDatesTimezoneDescription',
    NonCustomerPeriodWarningMessage: 'NonCustomerPeriodWarningMessage',
    DeliveryMethod: 'DeliveryMethod',
    NonMarketingCJInfoMessage: 'NonMarketingCJInfoMessage',
    LastExecutionStatus: 'LastExecutionStatus',
    LastVersion: 'LastVersion',
    SchedulerExecutionTimeTooltip: 'SchedulerExecutionTimeTooltip',
    SchedulerTimeZoneTooltip: 'SchedulerTimeZoneTooltip',
    CommunicationCount: 'CommunicationCount',
    NonMarketing: 'NonMarketing',
    Public: 'Public',
    PublicCJInfoMessage: 'PublicCJInfoMessage',
    PublicCampaign: 'PublicCampaign',
    PublicPromotion: 'PublicPromotion',
    PublicCampaignDescription: 'PublicCampaignDescription',
    PublicPromotionDescription: 'PublicPromotionDescription',
    BudgetLimitRequiredForAwards: 'BudgetLimitRequiredForAwards',
    BudgetLimitWarningForPublicPromotions: 'BudgetLimitWarningForPublicPromotions',
    BudgetLimitNotApplicableForPublicPromotions: 'BudgetLimitNotApplicableForPublicPromotions',
    PublicCampaignDisabledReasonRelatedToBudgetLimit: 'PublicCampaignDisabledReasonRelatedToBudgetLimit',
    PublicPromotionDisabledReasonRelatedToBudgetLimit: 'PublicPromotionDisabledReasonRelatedToBudgetLimit',
    ABTestCampaignCanNotBePublic: 'ABTestCampaignCanNotBePublic',
    ABTestCampaignCanNotBeNonMarketing: 'ABTestCampaignCanNotBeNonMarketing',
    CampaignNewExecutionNotification: 'CampaignNewExecutionNotification',
    Configurations: 'Configurations',
    PredefinedTemplateWasSuccessfullySaved: 'PredefinedTemplateWasSuccessfullySaved',
    PredefinedList: 'PredefinedList',
    ExclusiveMode: 'ExclusiveMode',
    ExclusiveModeDescription: 'ExclusiveModeDescription',
    SavePredefinedTelegramTemplate: 'SavePredefinedTelegramTemplate',
    CoolDownPeriod: 'CoolDownPeriod',
    CoolDownPeriodDays: 'CoolDownPeriodDays',
    MakePublic: 'MakePublic',
    PromoCategory: 'PromoCategory',
    MakePrivate: 'MakePrivate',
    DetectionMethod: 'DetectionMethod',
    UpgradeSubscriptionPlanInfoMessage: 'UpgradeSubscriptionPlanInfoMessage',
    PleaseFillAllFieldsAndApply: 'PleaseFillAllFieldsAndApply',
    ZScore: 'ZScore',
    PleaseSelectSegmentAndKPI: 'PleaseSelectSegmentAndKPI',
    InterQuartileRange: 'InterQuartileRange',
    MedianAbsoluteDeviation: 'MedianAbsoluteDeviation',
    MakePublicSelectedCampaigns: 'MakePublicSelectedCampaigns',
    AllowMakePublicSelectedCampaigns: 'AllowMakePublicSelectedCampaigns',
    NotAllowMakePublicSelectedCampaigns: 'NotAllowMakePublicSelectedCampaigns',
    MakePublicSelectedCampaignsQuestion: 'MakePublicSelectedCampaignsQuestion',
    MakePrivateSelectedCampaigns: 'MakePrivateSelectedCampaigns',
    AllowMakePrivateSelectedCampaigns: 'AllowMakePrivateSelectedCampaigns',
    NotAllowMakePrivateSelectedCampaigns: 'NotAllowMakePrivateSelectedCampaigns',
    MakePrivateSelectedCampaignsQuestion: 'MakePrivateSelectedCampaignsQuestion',
    MakePublicSelectedCustomerJourneys: 'MakePublicSelectedCustomerJourneys',
    AllowMakePublicSelectedCustomerJourneys: 'AllowMakePublicSelectedCustomerJourneys',
    NotAllowMakePublicSelectedCustomerJourneys: 'NotAllowMakePublicSelectedCustomerJourneys',
    MakePublicSelectedCustomerJourneysQuestion: 'MakePublicSelectedCustomerJourneysQuestion',
    MakePrivateSelectedCustomerJourneys: 'MakePrivateSelectedCustomerJourneys',
    AllowMakePrivateSelectedCustomerJourneys: 'AllowMakePrivateSelectedCustomerJourneys',
    CreatePredefinedSMSTemplate: 'CreatePredefinedSMSTemplate',
    SavePredefinedPushNotificationTemplate: 'SavePredefinedPushNotificationTemplate',
    NotAllowMakePrivateSelectedCustomerJourneys: 'NotAllowMakePrivateSelectedCustomerJourneys',
    MakePrivateSelectedCustomerJourneysQuestion: 'MakePrivateSelectedCustomerJourneysQuestion',
    CreatePredefinedTelegramTemplate: 'CreatePredefinedTelegramTemplate',
    SavePredefinedEmailTemplate: 'SavePredefinedEmailTemplate',
    EditPredefinedSMSTemplate: 'EditPredefinedSMSTemplate',
    SavePredefinedReport: 'SavePredefinedReport',
    CurrentMAU: 'CurrentMAU',
    PreviousMAU: 'PreviousMAU',
    CompositeOperation: 'CompositeOperation',
    SegmentSpecificDataHintTooltipText: 'SegmentSpecificDataHintTooltipText',
    SegmentSpecificDataNoHint: 'SegmentSpecificDataNoHint',
    PredefinedSegmentWasSuccessfullySaved: 'PredefinedSegmentWasSuccessfullySaved',
    SavePredefinedCustomerJourney: 'SavePredefinedCustomerJourney',
    AISegmentation: 'AISegmentation',
    CreatePredefinedDynamicSegment: 'CreatePredefinedDynamicSegment',
    CreatePredefinedObjects: 'CreatePredefinedObjects',
    UnifiedCurrency: 'UnifiedCurrency',
    Categories: 'Categories',
    SelectSegment: 'SelectSegment',
    AreYouSureYouWantToDeletePredefined: 'AreYouSureYouWantToDeletePredefined', // {{objectName}}
    LoadedSegments: 'LoadedSegments',
    CreatePredefinedActionCampaign: 'CreatePredefinedActionCampaign',
    SavePredefinedInternalMessageTemplate: 'SavePredefinedInternalMessageTemplate',
    ObjectType: 'ObjectType',
    CurrentMAUDescription: 'CurrentMAUDescription',
    PreviousMAUDescription: 'PreviousMAUDescription',
    PreviousValue: 'PreviousValue',
    NextValue: 'NextValue',
    DeletePredefinedTitle: 'DeletePredefinedTitle', // {{objectType}}
    CloneAsLive: 'CloneAsLive',
    CloneAsPredefined: 'CloneAsPredefined',
    SavePredefinedViberTemplate: 'SavePredefinedViberTemplate',
    SavePredefinedHooryTemplate: 'SavePredefinedHooryTemplate',
    CreatePredefinedHooryTemplate: 'CreatePredefinedHooryTemplate',
    EditPredefinedDynamicPopUpTemplate: 'EditPredefinedDynamicPopUpTemplate',
    EditPredefinedPushNotificationTemplate: 'EditPredefinedPushNotificationTemplate',
    EditPredefinedViberTemplate: 'EditPredefinedViberTemplate',
    EditPredefinedHooryTemplate: 'EditPredefinedHooryTemplate',
    EditPredefinedReport: 'EditPredefinedReport',
    SavePredefinedRealtimeActionCampaign: 'SavePredefinedRealtimeActionCampaign',
    LoadData: 'LoadData',
    DataPreview: 'DataPreview',
    SegmentCreatedSuccessfully: 'SegmentCreatedSuccessfully',
    AddFreeChipSpinExchangeRate: 'AddFreeChipSpinExchangeRate',
    FreeSpinPrice: 'FreeSpinPrice',
    StatisticalAnalysis: 'StatisticalAnalysis',
    SaveTheExclusionRuleWhileLoadingPreviewMessage: 'SaveTheExclusionRuleWhileLoadingPreviewMessage',
    BonusId: 'BonusId',
    ClonePredefinedCustomerJourney: 'ClonePredefinedCustomerJourney',
    PlayerCurrency: 'PlayerCurrency',
    ClonePredefinedReport: ' ClonePredefinedReport',
    ClonePredefinedSegment: 'ClonePredefinedSegment',
    Statistic: 'Statistic',
    EditFreeChipSpinExchangeRate: 'EditFreeChipSpinExchangeRate',
    DeleteFreeChipSpinExchangeRate: 'DeleteFreeChipSpinExchangeRate',
    SetDefaultFreeChipSpinExchangeRate: 'SetDefaultFreeChipSpinExchangeRate',
    AreYouSureYouWantToDeleteFreeChipSpinExchangeRate: 'AreYouSureYouWantToDeleteFreeChipSpinExchangeRate',
    ExclusionRuleName: 'ExclusionRuleName',
    Overall: 'Overall',
    CampaignSchedule: 'CampaignSchedule',
    PreCalculation: 'PreCalculation',
    PreCalculationSchedule: 'PreCalculationSchedule',
    PreCalculationDescription: 'PreCalculationDescription',
    PreCalculationHoursDescription: 'PreCalculationHoursDescription',
    PreCalculationInstructions: 'PreCalculationInstructions',
    PreCalculationActivationInfo: 'PreCalculationActivationInfo',
    PreCalculationWarningAboutLessHours: 'PreCalculationWarningAboutLessHours',
    PreCalculationWarningAboutPreviousDay: 'PreCalculationWarningAboutPreviousDay',
    PreCalculationStatus: 'PreCalculationStatus',
    PreCalculationInProgress: 'PreCalculationInProgress',
    PreCalculationCompleted: 'PreCalculationCompleted', // with params {{date}}
    PreCalculationFailed: 'PreCalculationFailed',
    PreCalculationStopped: 'PreCalculationStopped',
    HoursWithCount: 'HoursWithCount', // with params {{count}} // {count} hours
    Immediately: 'Immediately',
    ExecutedSegmentCount: 'ExecutedSegmentCount',
    BonusAmount: 'BonusAmount',
    ClonePredefinedActionCampaign: 'ClonePredefinedActionCampaign',
    ClonePredefinedInternalMessageTemplate: 'ClonePredefinedInternalMessageTemplate',
    AIAssistant: 'AIAssistant',
    PartnerPackagePlan: 'PartnerPackagePlan',
    ClonePredefinedViberTemplate: 'ClonePredefinedViberTemplate',
    ClonePredefinedHooryTemplate: 'ClonePredefinedHooryTemplate',
    ClonePredefinedPushNotificationTemplate: 'ClonePredefinedPushNotificationTemplate',
    ClonePredefinedEmailTemplate: 'ClonePredefinedEmailTemplate',
    ClonePredefinedSMSTemplate: 'ClonePredefinedSMSTemplate',
    ClonePredefinedDynamicPopUpTemplate: 'ClonePredefinedDynamicPopUpTemplate',
    CreateExclusionRules: 'CreateExclusionRules',
    ExclusionRulesManagement: 'ExclusionRulesManagement',
    ExclusionRulesManagementDescription: 'ExclusionRulesManagementDescription',
    DeleteExclusionRuleTitle: 'DeleteExclusionRuleTitle',
    ExclusionRulesManagementCreate: 'ExclusionRulesManagementCreate',
    ExclusionRulesManagementEdit: 'ExclusionRulesManagementEdit',
    AreYouSureYouWantToArchiveExclusionRule: 'AreYouSureYouWantToArchiveExclusionRule', // {exclusionRuleName}
    AreYouSureYouWantToUnArchiveExclusionRule: 'AreYouSureYouWantToUnArchiveExclusionRule', // {exclusionRuleName}
    AreYouSureYouWantToDeleteExclusionRule: 'AreYouSureYouWantToDeleteExclusionRule', //{objectName}
    ExclusionRuleId: 'ExclusionRuleId',
    ExclusionRules: 'ExclusionRules',
    ExclusionRulesAlertMessage: 'ExclusionRulesAlertMessage',
    MarkAsRead: 'MarkAsRead',
    MarkAsUnread: 'MarkAsUnread',
    NoNotificationsYet: 'NoNotificationsYet',
    HowToAsk: 'HowToAsk',
    HowToAskHint: 'HowToAskHint',
    EditExclusionRule: 'EditExclusionRule',
    ExclusionRule: 'ExclusionRule',
    ArchiveExclusionRule: 'ArchiveExclusionRule',
    UnArchiveExclusionRule: 'UnArchiveExclusionRule',
    DeleteExclusionRule: 'DeleteExclusionRule',
    NewNotification: 'NewNotification',
    ExclusionRuleInfo: 'ExclusionRuleInfo',
    Unread: 'Unread',
    ExclusionRuleWasSuccessfullySaved: 'ExclusionRuleWasSuccessfullySaved',
    Question: 'Question',
    PredefinedMarketingText: 'PredefinedMarketingText',
    PaidAmount: 'PaidAmount',
    ResultDate: 'ResultDate',
    AcceptanceDate: 'AcceptanceDate',
    MarkAllAsRead: 'MarkAllAsRead',
    AskAQuestionAboutYourData: 'AskAQuestionAboutYourData',
    Analyze: 'Analyze',
    GeneratedData: 'GeneratedData',
    ClonePredefinedTelegramTemplate: 'ClonePredefinedTelegramTemplate',
    Thinking: 'Thinking',
    Limit: 'Limit',
    NoLimit: 'NoLimit',
    LimitValue: 'LimitValue',
    UsedLimit: 'UsedLimit',
    NearLimit: 'NearLimit',
    Exceeded: 'Exceeded',
    FromPercentageToPercentage: 'FromPercentageToPercentage', // from {from}% to {to}%
    MappingDetails: 'MappingDetails',
    ImageURLPlaceholderDropdownErrorText: 'ImageURLPlaceholderDropdownErrorText',
    ImageURLPlaceholderDropdown: 'ImageURLPlaceholderDropdown',
    Placeholder: 'Placeholder',
    TheFeatureIsNotIncludedInYourPackage: 'TheFeatureIsNotIncludedInYourPackage',
    TrackingPeriod: 'TrackingPeriod',
    EfficiencyReport: 'EfficiencyReport',
    BeforePromo: 'BeforePromo',
    AfterPromo: 'AfterPromo',
    GoBackToOldVersionWithWarningMessage: 'GoBackToOldVersionWithWarningMessage',
    ParametersList: 'ParametersList',
    Operators: 'Operators',
    Constant: 'Constant',
    FormulaJourney: 'FormulaJourney',
    DragItemsHereToBuildYourFormula: 'DragItemsHereToBuildYourFormula',
    FormulaItems: 'FormulaItems',
    FormulaFilters: 'FormulaFilters',
    FormulaFiltersDescription: 'FormulaFiltersDescription',
    ParametersView: 'ParametersView',
    FormulaWillBeDisplayed: 'FormulaWillBeDisplayed',
    AtLeastOneComponentShouldBeUsed: 'AtLeastOneComponentShouldBeUsed',
    InvalidResultType: 'InvalidResultType',
    ReturnTypeIs: 'ReturnTypeIs',
    UnbalancedParentheses: 'UnbalancedParentheses',
    FormulaCannotStartWithOperator: 'FormulaCannotStartWithOperator',
    FormulaCannotEndWithOperator: 'FormulaCannotEndWithOperator',
    ConsecutiveOperatorsNotAllowed: 'ConsecutiveOperatorsNotAllowed',
    MissingOperatorBetweenValues: 'MissingOperatorBetweenValues',
    SaveFormulaFilter: 'SaveFormulaFilter',
    FormulaFilterSavedSuccessfully: 'FormulaFilterSavedSuccessfully',
    FormulaFilterList: 'FormulaFilterList',
    FilterId: 'FilterId',
    SearchBlocks: 'SearchBlocks',
    Achievements: 'Achievements',
    AchievementsDescription: 'AchievementsDescription',
    CreateAchievement: 'CreateAchievement',
    ArchiveAchievement: 'ArchiveAchievement',
    UnarchiveAchievement: 'UnarchiveAchievement',
    DeleteAchievement: 'DeleteAchievement',
    AreYouSureYouWantToDeleteAchievement: 'AreYouSureYouWantToDeleteAchievement', // with params {name}
    AreYouSureYouWantToArchiveAchievement: 'AreYouSureYouWantToArchiveAchievement', // with params {name}
    AreYouSureYouWantToUnarchiveAchievement: 'AreYouSureYouWantToUnarchiveAchievement', // with params {name}
    StartedIn: 'StartedIn',
    AwardAmount: 'AwardAmount',
    AwardAmountHint: 'AwardAmountHint',
    PreviewImage: 'PreviewImage',
    CreateFormulaFilter: 'CreateFormulaFilter',
    EditFormulaFilter: 'EditFormulaFilter',
    CloneFormulaFilter: 'CloneFormulaFilter',
    DeleteFormulaFilter: 'DeleteFormulaFilter',
    ArchiveFormulaFilter: 'ArchiveFormulaFilter',
    UnarchiveFormulaFilter: 'UnarchiveFormulaFilter',
    SearchByNameOrId: 'SearchByNameOrId',
    Banners: 'Banners',
    AreYouSureYouWantToDeleteFormulaFilter: 'AreYouSureYouWantToDeleteFormulaFilter', // with params {formulaFilterName}
    AreYouSureYouWantToArchiveFormulaFilter: 'AreYouSureYouWantToArchiveFormulaFilter', // with params {formulaFilterName}
    AreYouSureYouWantToUnarchiveFormulaFilter: 'AreYouSureYouWantToUnarchiveFormulaFilter', // with params {formulaFilterName}
    FromSentDate: 'FromSentDate',
    FormulaPreviewTooltipText: 'FormulaPreviewTooltipText',
    Period: 'Period',
    ZoomIn: 'ZoomIn',
    ZoomOut: 'ZoomOut',
    TurnOnFullScreen: 'TurnOnFullScreen',
    TurnOffFullScreen: 'TurnOffFullScreen',
    FitView: 'FitView',
    Undo: 'Undo',
    Redo: 'Redo',
    BonusConfiguration: 'BonusConfiguration',
    BudgetGroup: 'BudgetGroup',
    BudgetGroupName: 'BudgetGroupName',
    CreateBudgetGroup: 'CreateBudgetGroup',
    DeleteBudgetGroup: 'DeleteBudgetGroup',
    BudgetBonusGroups: 'BudgetBonusGroups',
    RemainingBlocksToAddBudgetOutOfTotal: 'RemainingBlocksToAddBudgetOutOfTotal',
    BonusSelectionOrRateIsInvalid: 'BonusSelectionOrRateIsInvalid',
    AreYouSureYouWantToDeleteBudgetGroup: 'AreYouSureYouWantToDeleteBudgetGroup', // with params {budgetGroupName}
    BlockIDMustBeUnique: 'BlockIDMustBeUnique',
    AddAtLeastOneBonusBlockToEnableBudget: 'AddAtLeastOneBonusBlockToEnableBudget',
    UnsubscribeCountTooltipInfoMessage: 'UnsubscribeCountTooltipInfoMessage',
    FormulaFilterInfo: 'FormulaFilterInfo',
    TooltipBudgetGroupName: 'TooltipBudgetGroupName',
    BonusInfoSectionTitle: 'BonusInfoSectionTitle',
    BonusBlocksListInfo: 'BonusBlocksListInfo',
    BudgetGroupNameAlreadyExists: 'BudgetGroupNameAlreadyExists',
    HasActiveBudget: 'HasActiveBudget',
    ClientsWhoClickedOnUnsubscribeLink: 'ClientsWhoClickedOnUnsubscribeLink',
    OnThisPage: 'OnThisPage',
    BonusBlocks: 'BonusBlocks',
    BlockInfo: 'BlockInfo',
    BlockRemoved: 'BlockRemoved',
    BlocksUsed: 'BlocksUsed',
    SuccessSentCount: 'SuccessSentCount',
    SuccessSentAmount: 'SuccessSentAmount',
    GroupName: 'GroupName',
    Behavior: 'Behavior',
    Spent: 'Spent',
    BudgetGroupInfo: 'BudgetGroupInfo',
    KnowledgeCenter: 'KnowledgeCenter',
    KnowledgeCenterSearch: 'KnowledgeCenterSearch',
    AchievementProvidersSelectAllInfo: 'AchievementProvidersSelectAllInfo',
    PleaseSelectProviders: 'PleaseSelectProviders',
    SelectingAProviderAppliesToAllExistingAndFutureGamesAndCategories:
        'SelectingAProviderAppliesToAllExistingAndFutureGamesAndCategories',
    Sports: 'Sports',
    Selection: 'Selection',
    AchievementSavedSuccessfully: 'AchievementSavedSuccessfully',
    AchievementSportsSelectAllInfo: 'AchievementSportsSelectAllInfo',
    SelectingASportAppliesToAllExistingAndFutureRegionsAndCompetitions:
        'SelectingASportAppliesToAllExistingAndFutureRegionsAndCompetitions',
    PaymentSystems: 'PaymentSystems',
    AchievementPaymentSystemsSelectAllInfo: 'AchievementPaymentSystemsSelectAllInfo',
    FormulaFilterNotSupportedFilterColumn: 'FormulaFilterNotSupportedFilterColumn',
    FormulaFilterRootNodeIsNull: 'FormulaFilterRootNodeIsNull',
    FormulaFilterSchemaMaxCountExceeded: 'FormulaFilterSchemaMaxCountExceeded',
    FormulaFilterOperatorNodeMissingRequiredChildren: 'FormulaFilterOperatorNodeMissingRequiredChildren',
    FormulaFilterOperatorNodeDivisionByZero: 'FormulaFilterOperatorNodeDivisionByZero',
    FormulaFilterOperatorAddSubtractChildrenTypeMismatch: 'FormulaFilterOperatorAddSubtractChildrenTypeMismatch',
    FormulaFilterReturnTypeCurrencyToPower: 'FormulaFilterReturnTypeCurrencyToPower',
    FormulaFilterReturnTypePercentToPower: 'FormulaFilterReturnTypePercentToPower',
    FormulaFilterReturnTypeMultiplicationIncompatibleTypes: 'FormulaFilterReturnTypeMultiplicationIncompatibleTypes',
    FormulaFilterConstantValueRequired: 'FormulaFilterConstantValueRequired',
    FormulaFilterConstantCurrencyRequired: 'FormulaFilterConstantCurrencyRequired',
    FormulaFilterSchemaCountTooltipDescription: 'FormulaFilterSchemaCountTooltipDescription',
    FormulaUnexpectedToken: 'FormulaUnexpectedToken',
    FormulaUnexpectedEndOfExpression: 'FormulaUnexpectedEndOfExpression',
    AIEnhancementsTemplateBannerTitle: 'AIEnhancementsTemplateBannerTitle',
    AIEnhancementsTemplateBannerDescription: 'AIEnhancementsTemplateBannerDescription',
    TryAIAssistant: 'TryAIAssistant',
    UnsubscribeCount: 'UnsubscribeCount',
    AITemplateBuilder: 'AITemplateBuilder',
    PoweredByGemini: 'PoweredByGemini',
    YourAIGeneratedTemplateWillAppearHere: 'YourAIGeneratedTemplateWillAppearHere',
    PickAFewSuggestionsAddAnyDetailsThenHitGenerate: 'PickAFewSuggestionsAddAnyDetailsThenHitGenerate',
    DescribeYourTemplateIdea: 'DescribeYourTemplateIdea',
    AISuggestions: 'AISuggestions',
    SuggestedListOfImprovements: 'SuggestedListOfImprovements',
    ViewPromotionApproval: 'ViewPromotionApproval',
    Approve: 'Approve',
    Reject: 'Reject',
    AssignToMe: 'AssignToMe',
    Unassign: 'Unassign',
    ApproveRequest: 'ApproveRequest',
    AreYouSureYouWantToApproveRequest: 'AreYouSureYouWantToApproveRequest',
    ResponseMessage: 'ResponseMessage',
    RequestWasApprovedSuccessfully: 'RequestWasApprovedSuccessfully',
    CancelRequest: 'CancelRequest',
    AreYouSureYouWantToCancelRequest: 'AreYouSureYouWantToCancelRequest',
    RequestWasCancelledSuccessfully: 'RequestWasCancelledSuccessfully',
    RejectRequest: 'RejectRequest',
    AreYouSureYouWantToRejectRequest: 'AreYouSureYouWantToRejectRequest',
    RequestWasRejectedSuccessfully: 'RequestWasRejectedSuccessfully',
    ResponseMessageIsRequired: 'ResponseMessageIsRequired',
    ResponseMessageMaxLength: 'ResponseMessageMaxLength', // with params {length}
    Assign: 'Assign',
    AreYouSureYouWantToAssignRequestToYourself: 'AreYouSureYouWantToAssignRequestToYourself',
    AreYouSureYouWantToUnassignRequest: 'AreYouSureYouWantToUnassignRequest',
    RequestWasAssignedSuccessfully: 'RequestWasAssignedSuccessfully',
    RequestWasUnassignedSuccessfully: 'RequestWasUnassignedSuccessfully',
    PromoDetails: 'PromoDetails',
    ApprovalDetails: 'ApprovalDetails',
    ApprovalId: 'ApprovalId',
    ApprovalState: 'ApprovalState',
    ObjectId: 'ObjectId',
    PromotionApproval: 'PromotionApproval',
    PromotionApprovalDescription: 'PromotionApprovalDescription',
    PromotionApprovalList: 'PromotionApprovalList',
    IsAssigned: 'IsAssigned',
    Priority: 'Priority',
    Achievement: 'Achievement',
    AchievementList: 'AchievementList',
    AddChallenge: 'AddChallenge',
    ChallengeType: 'ChallengeType',
    CreateChallenge: 'CreateChallenge',
    PeriodCountLabel: 'PeriodCountLabel',
    NoChallengesToDisplay: 'NoChallengesToDisplay',
    NoChallengesToDisplaySubTitle: 'NoChallengesToDisplaySubTitle',
    NoSelectionsToDisplayTitle: 'NoSelectionsToDisplayTitle',
    NoSelectionsToDisplaySubTitle: 'NoSelectionsToDisplaySubTitle',
    CloneAchievement: 'CloneAchievement',
    ReportResultWillBeSentToYourEmail: 'ReportResultWillBeSentToYourEmail',
    Payment: 'Payment',
    PeriodCountPlaceholder: 'PeriodCountPlaceholder',
    SelectChallengeType: 'SelectChallengeType',
    Selections: 'Selections',
    SetupAmount: 'SetupAmount',
    SetupMinAmount: 'SetupMinAmount',
    Deadline: 'Deadline',
    AssignedTo: 'AssignedTo',
    Unassigned: 'Unassigned',
    AssignedDate: 'AssignedDate',
    Request: 'Request',
    RequestedBy: 'RequestedBy',
    RequestedDate: 'RequestedDate',
    RequesterComment: 'RequesterComment',
    Response: 'Response',
    RespondedBy: 'RespondedBy',
    RespondedDate: 'RespondedDate',
    ResponseComment: 'ResponseComment',
    ShowMore: 'ShowMore',
    ShowLess: 'ShowLess',
    EditAchievement: 'EditAchievement',
    Low: 'Low',
    High: 'High',
    SendToApproval: 'SendToApproval',
    WriteACommentForManagerToApprove: 'WriteACommentForManagerToApprove',
    TheCampaignWillBeSavedAsDraftUntilApproval: 'TheCampaignWillBeSavedAsDraftUntilApproval',
    DeadlineMustBeInTheFuture: 'DeadlineMustBeInTheFuture',
    CurrentStatus: 'CurrentStatus',
    Navigate: 'Navigate',
    AchievementInfo: 'AchievementInfo',
    Challenge: 'Challenge',
    Global: 'Global',
    SeeMore: 'SeeMore',
    SeeLess: 'SeeLess',
    YouHaveUnsavedChangesContinueToWorkOnLatestVersionOrDeclineTheChanges:
        'YouHaveUnsavedChangesContinueToWorkOnLatestVersionOrDeclineTheChanges',
    UnsavedChangesWereDiscardedBecauseTheCustomerJourneyWasUpdated:
        'UnsavedChangesWereDiscardedBecauseTheCustomerJourneyWasUpdated',
    UnsavedChangesWereDiscardedBecauseTheActionCampaignWasUpdated:
        'UnsavedChangesWereDiscardedBecauseTheActionCampaignWasUpdated',
    Discard: 'Discard',
    AllCategoriesAndGamesUnderProviderAreSelected: 'AllCategoriesAndGamesUnderProviderAreSelected', // with params {{name}}
    AllGamesUnderCategoryAreSelected: 'AllGamesUnderCategoryAreSelected', // with params {{name}}
    AllRegionsAndCompetitionsUnderSportAreSelected: 'AllRegionsAndCompetitionsUnderSportAreSelected', // with params {{name}}
    AllCompetitionsUnderRegionAreSelected: 'AllCompetitionsUnderRegionAreSelected', // with params {{name}}
    AllSelected: 'AllSelected',
    AllTheListedGameProvidersHaveBeenSelected: 'AllTheListedGameProvidersHaveBeenSelected',
    AllTheListedSportsHaveBeenSelected: 'AllTheListedSportsHaveBeenSelected',
    AllTheListedPaymentSystemsHaveBeenSelected: 'AllTheListedPaymentSystemsHaveBeenSelected',
    PendingApprovalRequestMessage: 'PendingApprovalRequestMessage',
    ApprovedApprovalRequestMessage: 'ApprovedApprovalRequestMessage',
    RejectedApprovalRequestMessage: 'RejectedApprovalRequestMessage',
    CancelledApprovalRequestMessage: 'CancelledApprovalRequestMessage',
    MissedApprovalRequestMessage: 'MissedApprovalRequestMessage',
};

export { labels };

const allLabels = { ...administrationLabels, ...labels } as const;

type AllLocalizationLabelsType = typeof allLabels & { [key: string]: string };

const l = new Proxy(allLabels, {
    get(target, name) {
        return name in target ? target[name] : name;
    },
});

export default l as AllLocalizationLabelsType;
